/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminTenant,
  AiUsageDailyResponse,
  AiUsageResponse,
  ApiKey,
  AssignPlatformRoleRequest,
  AssistantEffectivePermissions,
  AssistantProfile,
  AssistantProfileUpdate,
  AuthUserResponse,
  BatchUserDeletionPreview,
  BatchUserDeletionPreviewRequest,
  CalendarEventCloneInput,
  CalendarShare,
  CalendarShareCreate,
  CalendarSharePatch,
  CalendarShareVisibility,
  CalendarShareVisibilityUpdate,
  ChecklistOccurrence,
  ChecklistRun,
  ClearStaleInvitationsResponse,
  ClearStaleUserInvitationsParams,
  ClonedCalendarEvent,
  ContactShare,
  ContactShareUpdate,
  CreateApiKeyRequest,
  CreatePlatformRoleRequest,
  CreateRecurringTasksResponse,
  CreateTaskRequest,
  CreateTaskResponse,
  CreateUserInvitationRequest,
  CreatedApiKey,
  CreatedUserInvitation,
  DeleteUserInvitationParams,
  DeletionRequest,
  DeletionRequestInput,
  DeletionRequestListItem,
  EmailOtpVerificationInput,
  EmailOtpVerificationResult,
  ErrorEnvelope,
  ErrorMessage,
  GetUserAiUsageDailyParams,
  GetUserAiUsageParams,
  GrantedResource,
  GrantedResourceUpdate,
  HealthStatus,
  InternalCalendar,
  InternalCalendarInput,
  InternalCalendarUpdate,
  ListSharedCalendarEventsParams,
  ListUserInvitationsParams,
  ListUsersParams,
  LoginRequest,
  LoginSuccessResponse,
  MoveUserRequest,
  MoveUserResponse,
  PlatformPermissionsResponse,
  PlatformRole,
  PlatformRoleAssignment,
  PlatformRoleAssignmentWithLabels,
  RelationshipSpendingApproval,
  RelationshipSpendingApprovalUpdate,
  RelationshipSpendingBudget,
  RelationshipSpendingBudgetUpdate,
  ResellerPlan,
  ResendInvitationResponse,
  ResetPasswordResult,
  ResourceGrant,
  ResourceGrantInput,
  ResourceGrantListItem,
  ResourceGrantUpdate,
  RetryGooglePushFailure,
  RetryGooglePushRequest,
  RetryGooglePushSuccess,
  RevokeApiKeyResult,
  ScheduleChecklistRequest,
  ScheduledChecklistEvent,
  SchedulerTriggerAccepted,
  ScorecardAnalyzeRequest,
  ScorecardAnalyzeResponse,
  ScorecardChatRequest,
  ScorecardChatResponse,
  ScorecardErrorResponse,
  ScorecardTrendPoint,
  ScorecardTrendRequest,
  SharedCalendarEvent,
  SuccessResponse,
  TaskBulkDeletionInput,
  TaskBulkDeletionResult,
  TwoFactorCode,
  TwoFactorConfirmation,
  TwoFactorSetup,
  TwoFactorStatus,
  TwoFactorVerification,
  UnscheduleChecklist200,
  UpdatePlatformRoleRequest,
  UpdateTenantPlanRequest,
  UpdateTenantPlanResult,
  UpdateUserInvitationRequest,
  UploadReservedObject200,
  UploadUrlRequest,
  UploadUrlResponse,
  UserDeletionPreview,
  UserInvitation,
  UserWithTenant,
  VisionBoard,
  VisionBoardInput
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Sign in with local credentials
 */
export const login = async (loginRequest: LoginRequest, options?: Parameters<typeof customFetch>[1]): Promise<LoginSuccessResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<LoginSuccessResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginRequest)
  }
);}





export const getLoginMutationKey = () => ['login'] as const;

export const getLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext> => {

const mutationKey = getLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, LoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = BodyType<LoginRequest>
    export type LoginMutationError = ErrorType<void>
    export type LoginMutationVariables = {data: BodyType<LoginRequest>}

    /**
 * @summary Sign in with local credentials
 */
export const useLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        LoginMutationVariables,
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }

export const getGetTwoFactorStatusUrl = () => {




  return `/api/auth/2fa/status`
}

/**
 * @summary Get the pending assistant's second-factor state
 */
export const getTwoFactorStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<TwoFactorStatus> => {

  return customFetch<TwoFactorStatus>(getGetTwoFactorStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTwoFactorStatusQueryKey = () => {
    return [
    `/api/auth/2fa/status`
    ] as const;
    }


export const getGetTwoFactorStatusQueryOptions = <TData = Awaited<ReturnType<typeof getTwoFactorStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTwoFactorStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTwoFactorStatus>>> = ({ signal }) => getTwoFactorStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTwoFactorStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTwoFactorStatus>>>
export type GetTwoFactorStatusQueryError = ErrorType<void>


/**
 * @summary Get the pending assistant's second-factor state
 */

export function useGetTwoFactorStatus<TData = Awaited<ReturnType<typeof getTwoFactorStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTwoFactorStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTwoFactorStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetupTwoFactorUrl = () => {




  return `/api/auth/2fa/setup`
}

/**
 * Returns the one-time enrollment secret. It is never returned after this response.
 * @summary Start TOTP enrollment
 */
export const setupTwoFactor = async ( options?: Parameters<typeof customFetch>[1]): Promise<TwoFactorSetup> => {

  return customFetch<TwoFactorSetup>(getSetupTwoFactorUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetupTwoFactorMutationKey = () => ['setupTwoFactor'] as const;

export const getSetupTwoFactorMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupTwoFactor>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setupTwoFactor>>, TError,void, TContext> => {

const mutationKey = getSetupTwoFactorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupTwoFactor>>, void> = () => {


          return  setupTwoFactor(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetupTwoFactorMutationResult = NonNullable<Awaited<ReturnType<typeof setupTwoFactor>>>

    export type SetupTwoFactorMutationError = ErrorType<void>


    /**
 * @summary Start TOTP enrollment
 */
export const useSetupTwoFactor = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupTwoFactor>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setupTwoFactor>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSetupTwoFactorMutationOptions(options));
    }

export const getConfirmTwoFactorUrl = () => {




  return `/api/auth/2fa/confirm`
}

/**
 * @summary Confirm TOTP enrollment
 */
export const confirmTwoFactor = async (twoFactorCode: TwoFactorCode, options?: Parameters<typeof customFetch>[1]): Promise<TwoFactorConfirmation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TwoFactorConfirmation>(getConfirmTwoFactorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoFactorCode)
  }
);}





export const getConfirmTwoFactorMutationKey = () => ['confirmTwoFactor'] as const;

export const getConfirmTwoFactorMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmTwoFactor>>, TError,ConfirmTwoFactorMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmTwoFactor>>, TError,ConfirmTwoFactorMutationVariables, TContext> => {

const mutationKey = getConfirmTwoFactorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmTwoFactor>>, ConfirmTwoFactorMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmTwoFactor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmTwoFactorMutationResult = NonNullable<Awaited<ReturnType<typeof confirmTwoFactor>>>
    export type ConfirmTwoFactorMutationBody = BodyType<TwoFactorCode>
    export type ConfirmTwoFactorMutationError = ErrorType<void>
    export type ConfirmTwoFactorMutationVariables = {data: BodyType<TwoFactorCode>}

    /**
 * @summary Confirm TOTP enrollment
 */
export const useConfirmTwoFactor = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmTwoFactor>>, TError,ConfirmTwoFactorMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmTwoFactor>>,
        TError,
        ConfirmTwoFactorMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmTwoFactorMutationOptions(options));
    }

export const getVerifyTwoFactorUrl = () => {




  return `/api/auth/2fa/verify`
}

/**
 * @summary Complete a TOTP challenge
 */
export const verifyTwoFactor = async (twoFactorCode: TwoFactorCode, options?: Parameters<typeof customFetch>[1]): Promise<TwoFactorVerification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TwoFactorVerification>(getVerifyTwoFactorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoFactorCode)
  }
);}





export const getVerifyTwoFactorMutationKey = () => ['verifyTwoFactor'] as const;

export const getVerifyTwoFactorMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactor>>, TError,VerifyTwoFactorMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactor>>, TError,VerifyTwoFactorMutationVariables, TContext> => {

const mutationKey = getVerifyTwoFactorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTwoFactor>>, VerifyTwoFactorMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifyTwoFactor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyTwoFactorMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTwoFactor>>>
    export type VerifyTwoFactorMutationBody = BodyType<TwoFactorCode>
    export type VerifyTwoFactorMutationError = ErrorType<void>
    export type VerifyTwoFactorMutationVariables = {data: BodyType<TwoFactorCode>}

    /**
 * @summary Complete a TOTP challenge
 */
export const useVerifyTwoFactor = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactor>>, TError,VerifyTwoFactorMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyTwoFactor>>,
        TError,
        VerifyTwoFactorMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyTwoFactorMutationOptions(options));
    }

export const getVerifyTwoFactorRecoveryUrl = () => {




  return `/api/auth/2fa/recovery`
}

/**
 * @summary Complete a second-factor challenge with a recovery code
 */
export const verifyTwoFactorRecovery = async (twoFactorCode: TwoFactorCode, options?: Parameters<typeof customFetch>[1]): Promise<TwoFactorVerification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TwoFactorVerification>(getVerifyTwoFactorRecoveryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoFactorCode)
  }
);}





export const getVerifyTwoFactorRecoveryMutationKey = () => ['verifyTwoFactorRecovery'] as const;

export const getVerifyTwoFactorRecoveryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorRecovery>>, TError,VerifyTwoFactorRecoveryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorRecovery>>, TError,VerifyTwoFactorRecoveryMutationVariables, TContext> => {

const mutationKey = getVerifyTwoFactorRecoveryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyTwoFactorRecovery>>, VerifyTwoFactorRecoveryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifyTwoFactorRecovery(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyTwoFactorRecoveryMutationResult = NonNullable<Awaited<ReturnType<typeof verifyTwoFactorRecovery>>>
    export type VerifyTwoFactorRecoveryMutationBody = BodyType<TwoFactorCode>
    export type VerifyTwoFactorRecoveryMutationError = ErrorType<void>
    export type VerifyTwoFactorRecoveryMutationVariables = {data: BodyType<TwoFactorCode>}

    /**
 * @summary Complete a second-factor challenge with a recovery code
 */
export const useVerifyTwoFactorRecovery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyTwoFactorRecovery>>, TError,VerifyTwoFactorRecoveryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyTwoFactorRecovery>>,
        TError,
        VerifyTwoFactorRecoveryMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyTwoFactorRecoveryMutationOptions(options));
    }

export const getVerifyEmailOtpUrl = () => {




  return `/api/auth/email-otp/verify`
}

/**
 * @summary Complete assistant email verification and optionally trust this device
 */
export const verifyEmailOtp = async (emailOtpVerificationInput: EmailOtpVerificationInput, options?: Parameters<typeof customFetch>[1]): Promise<EmailOtpVerificationResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<EmailOtpVerificationResult>(getVerifyEmailOtpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(emailOtpVerificationInput)
  }
);}





export const getVerifyEmailOtpMutationKey = () => ['verifyEmailOtp'] as const;

export const getVerifyEmailOtpMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmailOtp>>, TError,VerifyEmailOtpMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmailOtp>>, TError,VerifyEmailOtpMutationVariables, TContext> => {

const mutationKey = getVerifyEmailOtpMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmailOtp>>, VerifyEmailOtpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifyEmailOtp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailOtpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmailOtp>>>
    export type VerifyEmailOtpMutationBody = BodyType<EmailOtpVerificationInput>
    export type VerifyEmailOtpMutationError = ErrorType<void>
    export type VerifyEmailOtpMutationVariables = {data: BodyType<EmailOtpVerificationInput>}

    /**
 * @summary Complete assistant email verification and optionally trust this device
 */
export const useVerifyEmailOtp = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmailOtp>>, TError,VerifyEmailOtpMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmailOtp>>,
        TError,
        VerifyEmailOtpMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyEmailOtpMutationOptions(options));
    }

export const getGetUserAiUsageUrl = (params?: GetUserAiUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user/ai-usage?${stringifiedParams}` : `/api/user/ai-usage`
}

/**
 * Returns the authenticated tenant's AI token consumption for the requested billing month (defaulting to the current month), plus the estimated billed cost (with platform upcharge) and the tenant's plan type. Usage is metered — no cap enforcement.
 * @summary AI token usage for one billing month
 */
export const getUserAiUsage = async (params?: GetUserAiUsageParams, options?: Parameters<typeof customFetch>[1]): Promise<AiUsageResponse> => {

  return customFetch<AiUsageResponse>(getGetUserAiUsageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserAiUsageQueryKey = (params?: GetUserAiUsageParams,) => {
    return [
    `/api/user/ai-usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserAiUsageQueryOptions = <TData = Awaited<ReturnType<typeof getUserAiUsage>>, TError = ErrorType<ErrorMessage>>(params?: GetUserAiUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAiUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAiUsageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAiUsage>>> = ({ signal }) => getUserAiUsage(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAiUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAiUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAiUsage>>>
export type GetUserAiUsageQueryError = ErrorType<ErrorMessage>


/**
 * @summary AI token usage for one billing month
 */

export function useGetUserAiUsage<TData = Awaited<ReturnType<typeof getUserAiUsage>>, TError = ErrorType<ErrorMessage>>(
 params?: GetUserAiUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAiUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserAiUsageQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUserAiUsageDailyUrl = (params: GetUserAiUsageDailyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user/ai-usage/daily?${stringifiedParams}` : `/api/user/ai-usage/daily`
}

/**
 * Returns the authenticated tenant's per-day AI token consumption for a single feature in the requested billing month (defaulting to the current month), with estimated billed cost (platform upcharge applied). Days are bucketed in UTC. Days with no usage are omitted.
 * @summary Per-day AI token usage for one feature
 */
export const getUserAiUsageDaily = async (params: GetUserAiUsageDailyParams, options?: Parameters<typeof customFetch>[1]): Promise<AiUsageDailyResponse> => {

  return customFetch<AiUsageDailyResponse>(getGetUserAiUsageDailyUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserAiUsageDailyQueryKey = (params?: GetUserAiUsageDailyParams,) => {
    return [
    `/api/user/ai-usage/daily`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserAiUsageDailyQueryOptions = <TData = Awaited<ReturnType<typeof getUserAiUsageDaily>>, TError = ErrorType<ErrorMessage>>(params: GetUserAiUsageDailyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAiUsageDaily>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAiUsageDailyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAiUsageDaily>>> = ({ signal }) => getUserAiUsageDaily(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAiUsageDaily>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAiUsageDailyQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAiUsageDaily>>>
export type GetUserAiUsageDailyQueryError = ErrorType<ErrorMessage>


/**
 * @summary Per-day AI token usage for one feature
 */

export function useGetUserAiUsageDaily<TData = Awaited<ReturnType<typeof getUserAiUsageDaily>>, TError = ErrorType<ErrorMessage>>(
 params: GetUserAiUsageDailyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAiUsageDaily>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserAiUsageDailyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAuthUserUrl = () => {




  return `/api/auth/user`
}

/**
 * Returns the authenticated user and their tenant, or 401 when not logged in
 * @summary Get current authenticated user
 */
export const getAuthUser = async ( options?: Parameters<typeof customFetch>[1]): Promise<AuthUserResponse> => {

  return customFetch<AuthUserResponse>(getGetAuthUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuthUserQueryKey = () => {
    return [
    `/api/auth/user`
    ] as const;
    }


export const getGetAuthUserQueryOptions = <TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUser>>> = ({ signal }) => getAuthUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthUser>>>
export type GetAuthUserQueryError = ErrorType<ErrorMessage>


/**
 * @summary Get current authenticated user
 */

export function useGetAuthUser<TData = Awaited<ReturnType<typeof getAuthUser>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListContactSharesUrl = (id: string,) => {




  return `/api/contacts/${id}/shares`
}

/**
 * @summary List explicit grants for an owned contact
 */
export const listContactShares = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ContactShare[]> => {

  return customFetch<ContactShare[]>(getListContactSharesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListContactSharesQueryKey = (id: string,) => {
    return [
    `/api/contacts/${id}/shares`
    ] as const;
    }


export const getListContactSharesQueryOptions = <TData = Awaited<ReturnType<typeof listContactShares>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listContactShares>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContactSharesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContactShares>>> = ({ signal }) => listContactShares(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContactShares>>, TError, TData> & { queryKey: QueryKey }
}

export type ListContactSharesQueryResult = NonNullable<Awaited<ReturnType<typeof listContactShares>>>
export type ListContactSharesQueryError = ErrorType<void>


/**
 * @summary List explicit grants for an owned contact
 */

export function useListContactShares<TData = Awaited<ReturnType<typeof listContactShares>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listContactShares>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListContactSharesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReplaceContactSharesUrl = (id: string,) => {




  return `/api/contacts/${id}/shares`
}

/**
 * @summary Replace explicit grants for an owned contact
 */
export const replaceContactShares = async (id: string,
    contactShareUpdate: ContactShareUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ContactShare[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ContactShare[]>(getReplaceContactSharesUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contactShareUpdate)
  }
);}





export const getReplaceContactSharesMutationKey = () => ['replaceContactShares'] as const;

export const getReplaceContactSharesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceContactShares>>, TError,ReplaceContactSharesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceContactShares>>, TError,ReplaceContactSharesMutationVariables, TContext> => {

const mutationKey = getReplaceContactSharesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceContactShares>>, ReplaceContactSharesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  replaceContactShares(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceContactSharesMutationResult = NonNullable<Awaited<ReturnType<typeof replaceContactShares>>>
    export type ReplaceContactSharesMutationBody = BodyType<ContactShareUpdate>
    export type ReplaceContactSharesMutationError = ErrorType<unknown>
    export type ReplaceContactSharesMutationVariables = {id: string;data: BodyType<ContactShareUpdate>}

    /**
 * @summary Replace explicit grants for an owned contact
 */
export const useReplaceContactShares = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceContactShares>>, TError,ReplaceContactSharesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replaceContactShares>>,
        TError,
        ReplaceContactSharesMutationVariables,
        TContext
      > => {
      return useMutation(getReplaceContactSharesMutationOptions(options));
    }

export const getRevokeContactShareUrl = (id: string,
    userId: string,) => {




  return `/api/contacts/${id}/shares/${userId}`
}

/**
 * @summary Revoke one contact grant
 */
export const revokeContactShare = async (id: string,
    userId: string, options?: Parameters<typeof customFetch>[1]): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getRevokeContactShareUrl(id,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeContactShareMutationKey = () => ['revokeContactShare'] as const;

export const getRevokeContactShareMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeContactShare>>, TError,RevokeContactShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeContactShare>>, TError,RevokeContactShareMutationVariables, TContext> => {

const mutationKey = getRevokeContactShareMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeContactShare>>, RevokeContactShareMutationVariables> = (props) => {
          const {id,userId} = props ?? {};

          return  revokeContactShare(id,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeContactShareMutationResult = NonNullable<Awaited<ReturnType<typeof revokeContactShare>>>

    export type RevokeContactShareMutationError = ErrorType<unknown>
    export type RevokeContactShareMutationVariables = {id: string;userId: string}

    /**
 * @summary Revoke one contact grant
 */
export const useRevokeContactShare = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeContactShare>>, TError,RevokeContactShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeContactShare>>,
        TError,
        RevokeContactShareMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeContactShareMutationOptions(options));
    }

export const getListCalendarSharesUrl = () => {




  return `/api/calendar/shares`
}

/**
 * @summary List calendars shared by the caller
 */
export const listCalendarShares = async ( options?: Parameters<typeof customFetch>[1]): Promise<CalendarShare[]> => {

  return customFetch<CalendarShare[]>(getListCalendarSharesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarSharesQueryKey = () => {
    return [
    `/api/calendar/shares`
    ] as const;
    }


export const getListCalendarSharesQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarShares>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarShares>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarSharesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarShares>>> = ({ signal }) => listCalendarShares({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarShares>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCalendarSharesQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarShares>>>
export type ListCalendarSharesQueryError = ErrorType<unknown>


/**
 * @summary List calendars shared by the caller
 */

export function useListCalendarShares<TData = Awaited<ReturnType<typeof listCalendarShares>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarShares>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCalendarSharesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCalendarShareUrl = () => {




  return `/api/calendar/shares`
}

/**
 * @summary Share a calendar with eligible recipients
 */
export const createCalendarShare = async (calendarShareCreate: CalendarShareCreate, options?: Parameters<typeof customFetch>[1]): Promise<CalendarShare | CalendarShare[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CalendarShare | CalendarShare[]>(getCreateCalendarShareUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(calendarShareCreate)
  }
);}





export const getCreateCalendarShareMutationKey = () => ['createCalendarShare'] as const;

export const getCreateCalendarShareMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarShare>>, TError,CreateCalendarShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCalendarShare>>, TError,CreateCalendarShareMutationVariables, TContext> => {

const mutationKey = getCreateCalendarShareMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCalendarShare>>, CreateCalendarShareMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCalendarShare(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCalendarShareMutationResult = NonNullable<Awaited<ReturnType<typeof createCalendarShare>>>
    export type CreateCalendarShareMutationBody = BodyType<CalendarShareCreate>
    export type CreateCalendarShareMutationError = ErrorType<unknown>
    export type CreateCalendarShareMutationVariables = {data: BodyType<CalendarShareCreate>}

    /**
 * @summary Share a calendar with eligible recipients
 */
export const useCreateCalendarShare = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarShare>>, TError,CreateCalendarShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCalendarShare>>,
        TError,
        CreateCalendarShareMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCalendarShareMutationOptions(options));
    }

export const getListCalendarsSharedWithMeUrl = () => {




  return `/api/calendar/shared-with-me`
}

/**
 * @summary List calendars shared with the caller
 */
export const listCalendarsSharedWithMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<CalendarShare[]> => {

  return customFetch<CalendarShare[]>(getListCalendarsSharedWithMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarsSharedWithMeQueryKey = () => {
    return [
    `/api/calendar/shared-with-me`
    ] as const;
    }


export const getListCalendarsSharedWithMeQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarsSharedWithMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarsSharedWithMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarsSharedWithMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarsSharedWithMe>>> = ({ signal }) => listCalendarsSharedWithMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarsSharedWithMe>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCalendarsSharedWithMeQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarsSharedWithMe>>>
export type ListCalendarsSharedWithMeQueryError = ErrorType<unknown>


/**
 * @summary List calendars shared with the caller
 */

export function useListCalendarsSharedWithMe<TData = Awaited<ReturnType<typeof listCalendarsSharedWithMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarsSharedWithMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCalendarsSharedWithMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCalendarShareUrl = (shareId: string,) => {




  return `/api/calendar/shares/${shareId}`
}

/**
 * @summary Update a calendar share created by the caller
 */
export const updateCalendarShare = async (shareId: string,
    calendarSharePatch: CalendarSharePatch, options?: Parameters<typeof customFetch>[1]): Promise<CalendarShare> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CalendarShare>(getUpdateCalendarShareUrl(shareId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(calendarSharePatch)
  }
);}





export const getUpdateCalendarShareMutationKey = () => ['updateCalendarShare'] as const;

export const getUpdateCalendarShareMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarShare>>, TError,UpdateCalendarShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCalendarShare>>, TError,UpdateCalendarShareMutationVariables, TContext> => {

const mutationKey = getUpdateCalendarShareMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCalendarShare>>, UpdateCalendarShareMutationVariables> = (props) => {
          const {shareId,data} = props ?? {};

          return  updateCalendarShare(shareId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCalendarShareMutationResult = NonNullable<Awaited<ReturnType<typeof updateCalendarShare>>>
    export type UpdateCalendarShareMutationBody = BodyType<CalendarSharePatch>
    export type UpdateCalendarShareMutationError = ErrorType<unknown>
    export type UpdateCalendarShareMutationVariables = {shareId: string;data: BodyType<CalendarSharePatch>}

    /**
 * @summary Update a calendar share created by the caller
 */
export const useUpdateCalendarShare = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarShare>>, TError,UpdateCalendarShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCalendarShare>>,
        TError,
        UpdateCalendarShareMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCalendarShareMutationOptions(options));
    }

export const getRevokeCalendarShareUrl = (shareId: string,) => {




  return `/api/calendar/shares/${shareId}`
}

/**
 * @summary Revoke a calendar share created by the caller
 */
export const revokeCalendarShare = async (shareId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRevokeCalendarShareUrl(shareId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeCalendarShareMutationKey = () => ['revokeCalendarShare'] as const;

export const getRevokeCalendarShareMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCalendarShare>>, TError,RevokeCalendarShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeCalendarShare>>, TError,RevokeCalendarShareMutationVariables, TContext> => {

const mutationKey = getRevokeCalendarShareMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeCalendarShare>>, RevokeCalendarShareMutationVariables> = (props) => {
          const {shareId} = props ?? {};

          return  revokeCalendarShare(shareId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeCalendarShareMutationResult = NonNullable<Awaited<ReturnType<typeof revokeCalendarShare>>>

    export type RevokeCalendarShareMutationError = ErrorType<unknown>
    export type RevokeCalendarShareMutationVariables = {shareId: string}

    /**
 * @summary Revoke a calendar share created by the caller
 */
export const useRevokeCalendarShare = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeCalendarShare>>, TError,RevokeCalendarShareMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeCalendarShare>>,
        TError,
        RevokeCalendarShareMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeCalendarShareMutationOptions(options));
    }

export const getUpdateCalendarShareVisibilityUrl = (shareId: string,) => {




  return `/api/calendar/shared/${shareId}/visibility`
}

/**
 * @summary Set visibility of a received calendar share
 */
export const updateCalendarShareVisibility = async (shareId: string,
    calendarShareVisibilityUpdate: CalendarShareVisibilityUpdate, options?: Parameters<typeof customFetch>[1]): Promise<CalendarShareVisibility> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CalendarShareVisibility>(getUpdateCalendarShareVisibilityUrl(shareId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(calendarShareVisibilityUpdate)
  }
);}





export const getUpdateCalendarShareVisibilityMutationKey = () => ['updateCalendarShareVisibility'] as const;

export const getUpdateCalendarShareVisibilityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarShareVisibility>>, TError,UpdateCalendarShareVisibilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCalendarShareVisibility>>, TError,UpdateCalendarShareVisibilityMutationVariables, TContext> => {

const mutationKey = getUpdateCalendarShareVisibilityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCalendarShareVisibility>>, UpdateCalendarShareVisibilityMutationVariables> = (props) => {
          const {shareId,data} = props ?? {};

          return  updateCalendarShareVisibility(shareId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCalendarShareVisibilityMutationResult = NonNullable<Awaited<ReturnType<typeof updateCalendarShareVisibility>>>
    export type UpdateCalendarShareVisibilityMutationBody = BodyType<CalendarShareVisibilityUpdate>
    export type UpdateCalendarShareVisibilityMutationError = ErrorType<unknown>
    export type UpdateCalendarShareVisibilityMutationVariables = {shareId: string;data: BodyType<CalendarShareVisibilityUpdate>}

    /**
 * @summary Set visibility of a received calendar share
 */
export const useUpdateCalendarShareVisibility = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarShareVisibility>>, TError,UpdateCalendarShareVisibilityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCalendarShareVisibility>>,
        TError,
        UpdateCalendarShareVisibilityMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCalendarShareVisibilityMutationOptions(options));
    }

export const getListSharedCalendarEventsUrl = (params?: ListSharedCalendarEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/calendar/events/shared?${stringifiedParams}` : `/api/calendar/events/shared`
}

/**
 * @summary List events visible through received calendar shares
 */
export const listSharedCalendarEvents = async (params?: ListSharedCalendarEventsParams, options?: Parameters<typeof customFetch>[1]): Promise<SharedCalendarEvent[]> => {

  return customFetch<SharedCalendarEvent[]>(getListSharedCalendarEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSharedCalendarEventsQueryKey = (params?: ListSharedCalendarEventsParams,) => {
    return [
    `/api/calendar/events/shared`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSharedCalendarEventsQueryOptions = <TData = Awaited<ReturnType<typeof listSharedCalendarEvents>>, TError = ErrorType<unknown>>(params?: ListSharedCalendarEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSharedCalendarEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSharedCalendarEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedCalendarEvents>>> = ({ signal }) => listSharedCalendarEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSharedCalendarEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSharedCalendarEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listSharedCalendarEvents>>>
export type ListSharedCalendarEventsQueryError = ErrorType<unknown>


/**
 * @summary List events visible through received calendar shares
 */

export function useListSharedCalendarEvents<TData = Awaited<ReturnType<typeof listSharedCalendarEvents>>, TError = ErrorType<unknown>>(
 params?: ListSharedCalendarEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSharedCalendarEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSharedCalendarEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAssistantEffectivePermissionsUrl = () => {




  return `/api/assistants/effective-permissions`
}

/**
 * @summary Get live effective capability grants for the current assistant
 */
export const getAssistantEffectivePermissions = async ( options?: Parameters<typeof customFetch>[1]): Promise<AssistantEffectivePermissions> => {

  return customFetch<AssistantEffectivePermissions>(getGetAssistantEffectivePermissionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssistantEffectivePermissionsQueryKey = () => {
    return [
    `/api/assistants/effective-permissions`
    ] as const;
    }


export const getGetAssistantEffectivePermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantEffectivePermissions>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssistantEffectivePermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantEffectivePermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantEffectivePermissions>>> = ({ signal }) => getAssistantEffectivePermissions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantEffectivePermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAssistantEffectivePermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantEffectivePermissions>>>
export type GetAssistantEffectivePermissionsQueryError = ErrorType<void>


/**
 * @summary Get live effective capability grants for the current assistant
 */

export function useGetAssistantEffectivePermissions<TData = Awaited<ReturnType<typeof getAssistantEffectivePermissions>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAssistantEffectivePermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAssistantEffectivePermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAssistantProfileUrl = (userId: string,) => {




  return `/api/assistants/${userId}`
}

/**
 * @summary Update a managed assistant profile and its capability grants
 */
export const updateAssistantProfile = async (userId: string,
    assistantProfileUpdate: AssistantProfileUpdate, options?: Parameters<typeof customFetch>[1]): Promise<AssistantProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AssistantProfile>(getUpdateAssistantProfileUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(assistantProfileUpdate)
  }
);}





export const getUpdateAssistantProfileMutationKey = () => ['updateAssistantProfile'] as const;

export const getUpdateAssistantProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssistantProfile>>, TError,UpdateAssistantProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssistantProfile>>, TError,UpdateAssistantProfileMutationVariables, TContext> => {

const mutationKey = getUpdateAssistantProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssistantProfile>>, UpdateAssistantProfileMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  updateAssistantProfile(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssistantProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssistantProfile>>>
    export type UpdateAssistantProfileMutationBody = BodyType<AssistantProfileUpdate>
    export type UpdateAssistantProfileMutationError = ErrorType<void>
    export type UpdateAssistantProfileMutationVariables = {userId: string;data: BodyType<AssistantProfileUpdate>}

    /**
 * @summary Update a managed assistant profile and its capability grants
 */
export const useUpdateAssistantProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssistantProfile>>, TError,UpdateAssistantProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAssistantProfile>>,
        TError,
        UpdateAssistantProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAssistantProfileMutationOptions(options));
    }

export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users?${stringifiedParams}` : `/api/users`
}

/**
 * Returns users for the caller's tenant (admin) with the tenant name joined in. Master admins see all users across tenants, or can filter with the tenantId query parameter.
 * @summary List users
 */
export const listUsers = async (params?: ListUsersParams, options?: Parameters<typeof customFetch>[1]): Promise<UserWithTenant[]> => {

  return customFetch<UserWithTenant[]>(getListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/api/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ErrorMessage>>(params?: ListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<ErrorMessage>


/**
 * @summary List users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ErrorMessage>>(
 params?: ListUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAdminTenantsUrl = () => {




  return `/api/admin/tenants`
}

/**
 * Returns every tenant with a per-tenant user count and a summary list of its users. Master admin only.
 * @summary List all tenants (master admin)
 */
export const listAdminTenants = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminTenant[]> => {

  return customFetch<AdminTenant[]>(getListAdminTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminTenantsQueryKey = () => {
    return [
    `/api/admin/tenants`
    ] as const;
    }


export const getListAdminTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminTenants>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminTenants>>> = ({ signal }) => listAdminTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminTenants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminTenants>>>
export type ListAdminTenantsQueryError = ErrorType<ErrorMessage>


/**
 * @summary List all tenants (master admin)
 */

export function useListAdminTenants<TData = Awaited<ReturnType<typeof listAdminTenants>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminTenantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListResellerPlansUrl = () => {




  return `/api/reseller/plans`
}

/**
 * Returns all configured subscription/reseller plans. Master admin only.
 * @summary List subscription plans (master admin)
 */
export const listResellerPlans = async ( options?: Parameters<typeof customFetch>[1]): Promise<ResellerPlan[]> => {

  return customFetch<ResellerPlan[]>(getListResellerPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListResellerPlansQueryKey = () => {
    return [
    `/api/reseller/plans`
    ] as const;
    }


export const getListResellerPlansQueryOptions = <TData = Awaited<ReturnType<typeof listResellerPlans>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResellerPlans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResellerPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResellerPlans>>> = ({ signal }) => listResellerPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listResellerPlans>>, TError, TData> & { queryKey: QueryKey }
}

export type ListResellerPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listResellerPlans>>>
export type ListResellerPlansQueryError = ErrorType<ErrorMessage>


/**
 * @summary List subscription plans (master admin)
 */

export function useListResellerPlans<TData = Awaited<ReturnType<typeof listResellerPlans>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResellerPlans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListResellerPlansQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListUserInvitationsUrl = (params?: ListUserInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user-invitations?${stringifiedParams}` : `/api/user-invitations`
}

/**
 * Returns invitations for the caller's tenant (admin). Master admins see all invitations across tenants, or can filter with the tenantId query parameter. The plaintext invitation token is never included.
 * @summary List user invitations
 */
export const listUserInvitations = async (params?: ListUserInvitationsParams, options?: Parameters<typeof customFetch>[1]): Promise<UserInvitation[]> => {

  return customFetch<UserInvitation[]>(getListUserInvitationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserInvitationsQueryKey = (params?: ListUserInvitationsParams,) => {
    return [
    `/api/user-invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUserInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listUserInvitations>>, TError = ErrorType<ErrorMessage>>(params?: ListUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUserInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserInvitationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserInvitations>>> = ({ signal }) => listUserInvitations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUserInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserInvitations>>>
export type ListUserInvitationsQueryError = ErrorType<ErrorMessage>


/**
 * @summary List user invitations
 */

export function useListUserInvitations<TData = Awaited<ReturnType<typeof listUserInvitations>>, TError = ErrorType<ErrorMessage>>(
 params?: ListUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUserInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUserInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateUserInvitationUrl = () => {




  return `/api/user-invitations`
}

/**
 * Creates an invitation and emails the invitee. Master admins may target another tenant via tenantId and create reseller/admin invitations; tenant admins are restricted to member invitations in their own tenant.
 * @summary Create a user invitation
 */
export const createUserInvitation = async (createUserInvitationRequest: CreateUserInvitationRequest, options?: Parameters<typeof customFetch>[1]): Promise<CreatedUserInvitation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CreatedUserInvitation>(getCreateUserInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserInvitationRequest)
  }
);}





export const getCreateUserInvitationMutationKey = () => ['createUserInvitation'] as const;

export const getCreateUserInvitationMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserInvitation>>, TError,CreateUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserInvitation>>, TError,CreateUserInvitationMutationVariables, TContext> => {

const mutationKey = getCreateUserInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserInvitation>>, CreateUserInvitationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createUserInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createUserInvitation>>>
    export type CreateUserInvitationMutationBody = BodyType<CreateUserInvitationRequest>
    export type CreateUserInvitationMutationError = ErrorType<void | ErrorMessage>
    export type CreateUserInvitationMutationVariables = {data: BodyType<CreateUserInvitationRequest>}

    /**
 * @summary Create a user invitation
 */
export const useCreateUserInvitation = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserInvitation>>, TError,CreateUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUserInvitation>>,
        TError,
        CreateUserInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateUserInvitationMutationOptions(options));
    }

export const getUpdateUserInvitationUrl = (id: string,) => {




  return `/api/user-invitations/${id}`
}

/**
 * Updates email, first/last name, or role of a pending invitation. Only master admins may grant the admin role.
 * @summary Edit a pending invitation
 */
export const updateUserInvitation = async (id: string,
    updateUserInvitationRequest: UpdateUserInvitationRequest, options?: Parameters<typeof customFetch>[1]): Promise<UserInvitation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UserInvitation>(getUpdateUserInvitationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateUserInvitationRequest)
  }
);}





export const getUpdateUserInvitationMutationKey = () => ['updateUserInvitation'] as const;

export const getUpdateUserInvitationMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserInvitation>>, TError,UpdateUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserInvitation>>, TError,UpdateUserInvitationMutationVariables, TContext> => {

const mutationKey = getUpdateUserInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserInvitation>>, UpdateUserInvitationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateUserInvitation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserInvitation>>>
    export type UpdateUserInvitationMutationBody = BodyType<UpdateUserInvitationRequest>
    export type UpdateUserInvitationMutationError = ErrorType<void | ErrorMessage>
    export type UpdateUserInvitationMutationVariables = {id: string;data: BodyType<UpdateUserInvitationRequest>}

    /**
 * @summary Edit a pending invitation
 */
export const useUpdateUserInvitation = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserInvitation>>, TError,UpdateUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUserInvitation>>,
        TError,
        UpdateUserInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserInvitationMutationOptions(options));
    }

export const getDeleteUserInvitationUrl = (id: string,
    params?: DeleteUserInvitationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user-invitations/${id}?${stringifiedParams}` : `/api/user-invitations/${id}`
}

/**
 * Deletes an invitation. For accepted invitations, also deletes the user account that was created (force=true required when that user has data).
 * @summary Revoke an invitation
 */
export const deleteUserInvitation = async (id: string,
    params?: DeleteUserInvitationParams, options?: Parameters<typeof customFetch>[1]): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteUserInvitationUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserInvitationMutationKey = () => ['deleteUserInvitation'] as const;

export const getDeleteUserInvitationMutationOptions = <TError = ErrorType<ErrorMessage | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserInvitation>>, TError,DeleteUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserInvitation>>, TError,DeleteUserInvitationMutationVariables, TContext> => {

const mutationKey = getDeleteUserInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserInvitation>>, DeleteUserInvitationMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  deleteUserInvitation(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserInvitation>>>

    export type DeleteUserInvitationMutationError = ErrorType<ErrorMessage | void>
    export type DeleteUserInvitationMutationVariables = {id: string;params?: DeleteUserInvitationParams}

    /**
 * @summary Revoke an invitation
 */
export const useDeleteUserInvitation = <TError = ErrorType<ErrorMessage | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserInvitation>>, TError,DeleteUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserInvitation>>,
        TError,
        DeleteUserInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserInvitationMutationOptions(options));
    }

export const getClearStaleUserInvitationsUrl = (params?: ClearStaleUserInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user-invitations/stale?${stringifiedParams}` : `/api/user-invitations/stale`
}

/**
 * @summary Bulk-clear expired and cancelled invitations
 */
export const clearStaleUserInvitations = async (params?: ClearStaleUserInvitationsParams, options?: Parameters<typeof customFetch>[1]): Promise<ClearStaleInvitationsResponse> => {

  return customFetch<ClearStaleInvitationsResponse>(getClearStaleUserInvitationsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearStaleUserInvitationsMutationKey = () => ['clearStaleUserInvitations'] as const;

export const getClearStaleUserInvitationsMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearStaleUserInvitations>>, TError,ClearStaleUserInvitationsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearStaleUserInvitations>>, TError,ClearStaleUserInvitationsMutationVariables, TContext> => {

const mutationKey = getClearStaleUserInvitationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearStaleUserInvitations>>, ClearStaleUserInvitationsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  clearStaleUserInvitations(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearStaleUserInvitationsMutationResult = NonNullable<Awaited<ReturnType<typeof clearStaleUserInvitations>>>

    export type ClearStaleUserInvitationsMutationError = ErrorType<ErrorMessage>
    export type ClearStaleUserInvitationsMutationVariables = {params?: ClearStaleUserInvitationsParams}

    /**
 * @summary Bulk-clear expired and cancelled invitations
 */
export const useClearStaleUserInvitations = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearStaleUserInvitations>>, TError,ClearStaleUserInvitationsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof clearStaleUserInvitations>>,
        TError,
        ClearStaleUserInvitationsMutationVariables,
        TContext
      > => {
      return useMutation(getClearStaleUserInvitationsMutationOptions(options));
    }

export const getResendUserInvitationUrl = (id: string,) => {




  return `/api/user-invitations/${id}/resend`
}

/**
 * Rotates the invitation token, resets expiry to 7 days out, flips expired invitations back to pending, and re-sends the email.
 * @summary Resend an invitation email
 */
export const resendUserInvitation = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ResendInvitationResponse> => {

  return customFetch<ResendInvitationResponse>(getResendUserInvitationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendUserInvitationMutationKey = () => ['resendUserInvitation'] as const;

export const getResendUserInvitationMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendUserInvitation>>, TError,ResendUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendUserInvitation>>, TError,ResendUserInvitationMutationVariables, TContext> => {

const mutationKey = getResendUserInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendUserInvitation>>, ResendUserInvitationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  resendUserInvitation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendUserInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendUserInvitation>>>

    export type ResendUserInvitationMutationError = ErrorType<void | ErrorMessage>
    export type ResendUserInvitationMutationVariables = {id: string}

    /**
 * @summary Resend an invitation email
 */
export const useResendUserInvitation = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendUserInvitation>>, TError,ResendUserInvitationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendUserInvitation>>,
        TError,
        ResendUserInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getResendUserInvitationMutationOptions(options));
    }

export const getResetUserPasswordUrl = (id: string,) => {




  return `/api/users/${id}/reset-password`
}

/**
 * Generates a temporary password for the user, invalidates outstanding reset links, and emails the temporary password to them. Tenant-scoped.
 * @summary Reset a user's password (admin)
 */
export const resetUserPassword = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ResetPasswordResult> => {

  return customFetch<ResetPasswordResult>(getResetUserPasswordUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetUserPasswordMutationKey = () => ['resetUserPassword'] as const;

export const getResetUserPasswordMutationOptions = <TError = ErrorType<ErrorMessage | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,ResetUserPasswordMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,ResetUserPasswordMutationVariables, TContext> => {

const mutationKey = getResetUserPasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, ResetUserPasswordMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  resetUserPassword(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>

    export type ResetUserPasswordMutationError = ErrorType<ErrorMessage | void>
    export type ResetUserPasswordMutationVariables = {id: string}

    /**
 * @summary Reset a user's password (admin)
 */
export const useResetUserPassword = <TError = ErrorType<ErrorMessage | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,ResetUserPasswordMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPassword>>,
        TError,
        ResetUserPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getResetUserPasswordMutationOptions(options));
    }

export const getGetUserDeletionPreviewUrl = (id: string,) => {




  return `/api/users/${id}/deletion-preview`
}

/**
 * Returns counts of the user's AI conversations, goals, tasks, habits, and journal entries plus human-readable warnings. Used by the delete user and revoke-accepted-invitation dialogs.
 * @summary Preview data loss before deleting a user
 */
export const getUserDeletionPreview = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UserDeletionPreview> => {

  return customFetch<UserDeletionPreview>(getGetUserDeletionPreviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserDeletionPreviewQueryKey = (id: string,) => {
    return [
    `/api/users/${id}/deletion-preview`
    ] as const;
    }


export const getGetUserDeletionPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getUserDeletionPreview>>, TError = ErrorType<ErrorMessage | void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserDeletionPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDeletionPreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDeletionPreview>>> = ({ signal }) => getUserDeletionPreview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDeletionPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDeletionPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDeletionPreview>>>
export type GetUserDeletionPreviewQueryError = ErrorType<ErrorMessage | void>


/**
 * @summary Preview data loss before deleting a user
 */

export function useGetUserDeletionPreview<TData = Awaited<ReturnType<typeof getUserDeletionPreview>>, TError = ErrorType<ErrorMessage | void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserDeletionPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserDeletionPreviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBatchUserDeletionPreviewUrl = () => {




  return `/api/users/deletion-preview-batch`
}

/**
 * Aggregates AI conversation counts across the given users. Users that don't exist or belong to another tenant are silently skipped.
 * @summary Preview data loss before bulk-deleting users
 */
export const getBatchUserDeletionPreview = async (batchUserDeletionPreviewRequest: BatchUserDeletionPreviewRequest, options?: Parameters<typeof customFetch>[1]): Promise<BatchUserDeletionPreview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<BatchUserDeletionPreview>(getGetBatchUserDeletionPreviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(batchUserDeletionPreviewRequest)
  }
);}





export const getGetBatchUserDeletionPreviewMutationKey = () => ['getBatchUserDeletionPreview'] as const;

export const getGetBatchUserDeletionPreviewMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBatchUserDeletionPreview>>, TError,GetBatchUserDeletionPreviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getBatchUserDeletionPreview>>, TError,GetBatchUserDeletionPreviewMutationVariables, TContext> => {

const mutationKey = getGetBatchUserDeletionPreviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getBatchUserDeletionPreview>>, GetBatchUserDeletionPreviewMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getBatchUserDeletionPreview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetBatchUserDeletionPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof getBatchUserDeletionPreview>>>
    export type GetBatchUserDeletionPreviewMutationBody = BodyType<BatchUserDeletionPreviewRequest>
    export type GetBatchUserDeletionPreviewMutationError = ErrorType<void | ErrorMessage>
    export type GetBatchUserDeletionPreviewMutationVariables = {data: BodyType<BatchUserDeletionPreviewRequest>}

    /**
 * @summary Preview data loss before bulk-deleting users
 */
export const useGetBatchUserDeletionPreview = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBatchUserDeletionPreview>>, TError,GetBatchUserDeletionPreviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof getBatchUserDeletionPreview>>,
        TError,
        GetBatchUserDeletionPreviewMutationVariables,
        TContext
      > => {
      return useMutation(getGetBatchUserDeletionPreviewMutationOptions(options));
    }

export const getMoveUserToTenantUrl = () => {




  return `/api/admin/move-user`
}

/**
 * Atomically migrates a user and all of their data to the target tenant. Master admin only; callers cannot move their own account.
 * @summary Move a user to another tenant (master admin)
 */
export const moveUserToTenant = async (moveUserRequest: MoveUserRequest, options?: Parameters<typeof customFetch>[1]): Promise<MoveUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<MoveUserResponse>(getMoveUserToTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveUserRequest)
  }
);}





export const getMoveUserToTenantMutationKey = () => ['moveUserToTenant'] as const;

export const getMoveUserToTenantMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveUserToTenant>>, TError,MoveUserToTenantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moveUserToTenant>>, TError,MoveUserToTenantMutationVariables, TContext> => {

const mutationKey = getMoveUserToTenantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveUserToTenant>>, MoveUserToTenantMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  moveUserToTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveUserToTenantMutationResult = NonNullable<Awaited<ReturnType<typeof moveUserToTenant>>>
    export type MoveUserToTenantMutationBody = BodyType<MoveUserRequest>
    export type MoveUserToTenantMutationError = ErrorType<void | ErrorMessage>
    export type MoveUserToTenantMutationVariables = {data: BodyType<MoveUserRequest>}

    /**
 * @summary Move a user to another tenant (master admin)
 */
export const useMoveUserToTenant = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveUserToTenant>>, TError,MoveUserToTenantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof moveUserToTenant>>,
        TError,
        MoveUserToTenantMutationVariables,
        TContext
      > => {
      return useMutation(getMoveUserToTenantMutationOptions(options));
    }

export const getUpdateTenantPlanUrl = (id: string,) => {




  return `/api/admin/tenants/${id}/plan`
}

/**
 * Assigns the tenant to the given subscription plan, or unassigns it when planId is null. Master admin only.
 * @summary Change a tenant's subscription plan (master admin)
 */
export const updateTenantPlan = async (id: string,
    updateTenantPlanRequest: UpdateTenantPlanRequest, options?: Parameters<typeof customFetch>[1]): Promise<UpdateTenantPlanResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UpdateTenantPlanResult>(getUpdateTenantPlanUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTenantPlanRequest)
  }
);}





export const getUpdateTenantPlanMutationKey = () => ['updateTenantPlan'] as const;

export const getUpdateTenantPlanMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenantPlan>>, TError,UpdateTenantPlanMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenantPlan>>, TError,UpdateTenantPlanMutationVariables, TContext> => {

const mutationKey = getUpdateTenantPlanMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenantPlan>>, UpdateTenantPlanMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateTenantPlan(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantPlanMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenantPlan>>>
    export type UpdateTenantPlanMutationBody = BodyType<UpdateTenantPlanRequest>
    export type UpdateTenantPlanMutationError = ErrorType<void | ErrorMessage>
    export type UpdateTenantPlanMutationVariables = {id: string;data: BodyType<UpdateTenantPlanRequest>}

    /**
 * @summary Change a tenant's subscription plan (master admin)
 */
export const useUpdateTenantPlan = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenantPlan>>, TError,UpdateTenantPlanMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTenantPlan>>,
        TError,
        UpdateTenantPlanMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTenantPlanMutationOptions(options));
    }

export const getListApiKeysUrl = () => {




  return `/api/api-keys`
}

/**
 * Returns all API keys for the caller's tenant. The key hash is never included.
 * @summary List the tenant's API keys
 */
export const listApiKeys = async ( options?: Parameters<typeof customFetch>[1]): Promise<ApiKey[]> => {

  return customFetch<ApiKey[]>(getListApiKeysUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListApiKeysQueryKey = () => {
    return [
    `/api/api-keys`
    ] as const;
    }


export const getListApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof listApiKeys>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApiKeysQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeys>>> = ({ signal }) => listApiKeys({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listApiKeys>>>
export type ListApiKeysQueryError = ErrorType<ErrorMessage>


/**
 * @summary List the tenant's API keys
 */

export function useListApiKeys<TData = Awaited<ReturnType<typeof listApiKeys>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListApiKeysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateApiKeyUrl = () => {




  return `/api/api-keys`
}

/**
 * Creates a new API key for the caller's tenant. The plaintext key is returned once, only in this response.
 * @summary Create an API key
 */
export const createApiKey = async (createApiKeyRequest: CreateApiKeyRequest, options?: Parameters<typeof customFetch>[1]): Promise<CreatedApiKey> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CreatedApiKey>(getCreateApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createApiKeyRequest)
  }
);}





export const getCreateApiKeyMutationKey = () => ['createApiKey'] as const;

export const getCreateApiKeyMutationOptions = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,CreateApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,CreateApiKeyMutationVariables, TContext> => {

const mutationKey = getCreateApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApiKey>>, CreateApiKeyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createApiKey(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createApiKey>>>
    export type CreateApiKeyMutationBody = BodyType<CreateApiKeyRequest>
    export type CreateApiKeyMutationError = ErrorType<void | ErrorMessage>
    export type CreateApiKeyMutationVariables = {data: BodyType<CreateApiKeyRequest>}

    /**
 * @summary Create an API key
 */
export const useCreateApiKey = <TError = ErrorType<void | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,CreateApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createApiKey>>,
        TError,
        CreateApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getCreateApiKeyMutationOptions(options));
    }

export const getRevokeApiKeyUrl = (id: string,) => {




  return `/api/api-keys/${id}`
}

/**
 * @summary Revoke an API key
 */
export const revokeApiKey = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<RevokeApiKeyResult> => {

  return customFetch<RevokeApiKeyResult>(getRevokeApiKeyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeApiKeyMutationKey = () => ['revokeApiKey'] as const;

export const getRevokeApiKeyMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,RevokeApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,RevokeApiKeyMutationVariables, TContext> => {

const mutationKey = getRevokeApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeApiKey>>, RevokeApiKeyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  revokeApiKey(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeApiKey>>>

    export type RevokeApiKeyMutationError = ErrorType<ErrorMessage>
    export type RevokeApiKeyMutationVariables = {id: string}

    /**
 * @summary Revoke an API key
 */
export const useRevokeApiKey = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,RevokeApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeApiKey>>,
        TError,
        RevokeApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeApiKeyMutationOptions(options));
    }

export const getRotateApiKeyUrl = (id: string,) => {




  return `/api/api-keys/${id}/rotate`
}

/**
 * Replaces the key's secret with a new one. The new plaintext key is returned once, only in this response; the old key stops working.
 * @summary Rotate an API key
 */
export const rotateApiKey = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<CreatedApiKey> => {

  return customFetch<CreatedApiKey>(getRotateApiKeyUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRotateApiKeyMutationKey = () => ['rotateApiKey'] as const;

export const getRotateApiKeyMutationOptions = <TError = ErrorType<ErrorMessage | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateApiKey>>, TError,RotateApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateApiKey>>, TError,RotateApiKeyMutationVariables, TContext> => {

const mutationKey = getRotateApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateApiKey>>, RotateApiKeyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  rotateApiKey(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof rotateApiKey>>>

    export type RotateApiKeyMutationError = ErrorType<ErrorMessage | void>
    export type RotateApiKeyMutationVariables = {id: string}

    /**
 * @summary Rotate an API key
 */
export const useRotateApiKey = <TError = ErrorType<ErrorMessage | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateApiKey>>, TError,RotateApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateApiKey>>,
        TError,
        RotateApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getRotateApiKeyMutationOptions(options));
    }

export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * Returns a short-lived, authenticated upload URL bound to the validated
 * size and content type. The client sends metadata here, then PUTs the
 * exact file bytes to the returned URL.
 * @summary Request a validated URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: Parameters<typeof customFetch>[1]): Promise<UploadUrlResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestUploadUrlMutationKey = () => ['requestUploadUrl'] as const;

export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext> => {

const mutationKey = getRequestUploadUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, RequestUploadUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>
    export type RequestUploadUrlMutationVariables = {data: BodyType<UploadUrlRequest>}

    /**
 * @summary Request a validated URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        RequestUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetPublicObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * Unconditionally public — no authentication or ACL checks.
 * Searches PUBLIC_OBJECT_SEARCH_PATHS for the given file path.
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getPublicObject = async (filePath: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({ signal }) => getPublicObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: filePath !== null && filePath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicObject>>>
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadReservedObjectUrl = (objectId: string,) => {




  return `/api/storage/uploads/${objectId}`
}

/**
 * @summary Upload bytes to a validated object reservation
 */
export const uploadReservedObject = async (objectId: string,
    uploadReservedObjectBody: Blob, options?: Parameters<typeof customFetch>[1]): Promise<UploadReservedObject200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UploadReservedObject200>(getUploadReservedObjectUrl(objectId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': '*/*', ...getHeaders(options?.headers) },
    body: uploadReservedObjectBody
  }
);}





export const getUploadReservedObjectMutationKey = () => ['uploadReservedObject'] as const;

export const getUploadReservedObjectMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadReservedObject>>, TError,UploadReservedObjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadReservedObject>>, TError,UploadReservedObjectMutationVariables, TContext> => {

const mutationKey = getUploadReservedObjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadReservedObject>>, UploadReservedObjectMutationVariables> = (props) => {
          const {objectId,data} = props ?? {};

          return  uploadReservedObject(objectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadReservedObjectMutationResult = NonNullable<Awaited<ReturnType<typeof uploadReservedObject>>>
    export type UploadReservedObjectMutationBody = BodyType<Blob>
    export type UploadReservedObjectMutationError = ErrorType<ErrorEnvelope>
    export type UploadReservedObjectMutationVariables = {objectId: string;data: BodyType<Blob>}

    /**
 * @summary Upload bytes to a validated object reservation
 */
export const useUploadReservedObject = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadReservedObject>>, TError,UploadReservedObjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadReservedObject>>,
        TError,
        UploadReservedObjectMutationVariables,
        TContext
      > => {
      return useMutation(getUploadReservedObjectMutationOptions(options));
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * Serves object entities uploaded through validated reservations. These can optionally
 * be protected with authentication or ACL checks based on the use case.
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListChecklistTemplateHistoryUrl = (id: string,) => {




  return `/api/checklist-templates/${id}/history`
}

/**
 * Returns the template's run-history log — one entry per activation (load-from-template, daily instance start, or daily-cycle reset) with its start and completion stamps — newest first, capped at 200. View access to a shared template is sufficient.
 * @summary Run history for a checklist template
 */
export const listChecklistTemplateHistory = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ChecklistRun[]> => {

  return customFetch<ChecklistRun[]>(getListChecklistTemplateHistoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListChecklistTemplateHistoryQueryKey = (id: string,) => {
    return [
    `/api/checklist-templates/${id}/history`
    ] as const;
    }


export const getListChecklistTemplateHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listChecklistTemplateHistory>>, TError = ErrorType<ErrorMessage | ErrorEnvelope>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChecklistTemplateHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListChecklistTemplateHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listChecklistTemplateHistory>>> = ({ signal }) => listChecklistTemplateHistory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listChecklistTemplateHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListChecklistTemplateHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listChecklistTemplateHistory>>>
export type ListChecklistTemplateHistoryQueryError = ErrorType<ErrorMessage | ErrorEnvelope>


/**
 * @summary Run history for a checklist template
 */

export function useListChecklistTemplateHistory<TData = Awaited<ReturnType<typeof listChecklistTemplateHistory>>, TError = ErrorType<ErrorMessage | ErrorEnvelope>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChecklistTemplateHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListChecklistTemplateHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListChecklistOccurrencesUrl = (id: string,) => {




  return `/api/checklists/${id}/occurrences`
}

/**
 * Returns the calendar-event occurrences linked to the checklist on the CALLER's own calendar (tenant + user scoped), ordered by startTime. Each occurrence carries isCompleted/completedAt for its day, powering the completion-history UI. View access to a shared checklist is sufficient.
 * @summary List the caller's calendar-event occurrences for a checklist
 */
export const listChecklistOccurrences = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ChecklistOccurrence[]> => {

  return customFetch<ChecklistOccurrence[]>(getListChecklistOccurrencesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListChecklistOccurrencesQueryKey = (id: string,) => {
    return [
    `/api/checklists/${id}/occurrences`
    ] as const;
    }


export const getListChecklistOccurrencesQueryOptions = <TData = Awaited<ReturnType<typeof listChecklistOccurrences>>, TError = ErrorType<ErrorMessage | ErrorEnvelope>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChecklistOccurrences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListChecklistOccurrencesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listChecklistOccurrences>>> = ({ signal }) => listChecklistOccurrences(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listChecklistOccurrences>>, TError, TData> & { queryKey: QueryKey }
}

export type ListChecklistOccurrencesQueryResult = NonNullable<Awaited<ReturnType<typeof listChecklistOccurrences>>>
export type ListChecklistOccurrencesQueryError = ErrorType<ErrorMessage | ErrorEnvelope>


/**
 * @summary List the caller's calendar-event occurrences for a checklist
 */

export function useListChecklistOccurrences<TData = Awaited<ReturnType<typeof listChecklistOccurrences>>, TError = ErrorType<ErrorMessage | ErrorEnvelope>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChecklistOccurrences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListChecklistOccurrencesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getScheduleChecklistUrl = (id: string,) => {




  return `/api/checklists/${id}/schedule`
}

/**
 * Creates a calendar event (or bounded recurring series) for the checklist on the caller's calendar, optionally best-effort pushing it to ONE connected Google calendar. When the push is attempted but fails, the response carries googlePushFailed: true so the UI can offer a retry via the retry-google-push endpoint.
 * @summary Schedule a checklist on the caller's calendar
 */
export const scheduleChecklist = async (id: string,
    scheduleChecklistRequest: ScheduleChecklistRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScheduledChecklistEvent> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ScheduledChecklistEvent>(getScheduleChecklistUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scheduleChecklistRequest)
  }
);}





export const getScheduleChecklistMutationKey = () => ['scheduleChecklist'] as const;

export const getScheduleChecklistMutationOptions = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleChecklist>>, TError,ScheduleChecklistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleChecklist>>, TError,ScheduleChecklistMutationVariables, TContext> => {

const mutationKey = getScheduleChecklistMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleChecklist>>, ScheduleChecklistMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  scheduleChecklist(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleChecklist>>>
    export type ScheduleChecklistMutationBody = BodyType<ScheduleChecklistRequest>
    export type ScheduleChecklistMutationError = ErrorType<ErrorEnvelope | ErrorMessage>
    export type ScheduleChecklistMutationVariables = {id: string;data: BodyType<ScheduleChecklistRequest>}

    /**
 * @summary Schedule a checklist on the caller's calendar
 */
export const useScheduleChecklist = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleChecklist>>, TError,ScheduleChecklistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof scheduleChecklist>>,
        TError,
        ScheduleChecklistMutationVariables,
        TContext
      > => {
      return useMutation(getScheduleChecklistMutationOptions(options));
    }

export const getUnscheduleChecklistUrl = (id: string,) => {




  return `/api/checklists/${id}/schedule`
}

/**
 * Deletes ALL calendar events linked to the checklist on the CALLER's calendar (recurring series and one-offs), with best-effort cleanup of Google-pushed copies. Removing the recurring events also stops the checklist's daily reset cycle, which is driven by them.
 * @summary Stop a checklist's recurring schedule and remove its calendar events
 */
export const unscheduleChecklist = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UnscheduleChecklist200> => {

  return customFetch<UnscheduleChecklist200>(getUnscheduleChecklistUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnscheduleChecklistMutationKey = () => ['unscheduleChecklist'] as const;

export const getUnscheduleChecklistMutationOptions = <TError = ErrorType<ErrorMessage | ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unscheduleChecklist>>, TError,UnscheduleChecklistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unscheduleChecklist>>, TError,UnscheduleChecklistMutationVariables, TContext> => {

const mutationKey = getUnscheduleChecklistMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unscheduleChecklist>>, UnscheduleChecklistMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unscheduleChecklist(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnscheduleChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof unscheduleChecklist>>>

    export type UnscheduleChecklistMutationError = ErrorType<ErrorMessage | ErrorEnvelope>
    export type UnscheduleChecklistMutationVariables = {id: string}

    /**
 * @summary Stop a checklist's recurring schedule and remove its calendar events
 */
export const useUnscheduleChecklist = <TError = ErrorType<ErrorMessage | ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unscheduleChecklist>>, TError,UnscheduleChecklistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unscheduleChecklist>>,
        TError,
        UnscheduleChecklistMutationVariables,
        TContext
      > => {
      return useMutation(getUnscheduleChecklistMutationOptions(options));
    }

export const getRetryChecklistGooglePushUrl = (id: string,) => {




  return `/api/checklists/${id}/retry-google-push`
}

/**
 * Re-attempts the best-effort Google push for an already-created, still-unlinked local event or recurring series belonging to the caller. Returns 409 when the event is already linked to Google.
 * @summary Retry a failed Google Calendar push for a scheduled checklist
 */
export const retryChecklistGooglePush = async (id: string,
    retryGooglePushRequest: RetryGooglePushRequest, options?: Parameters<typeof customFetch>[1]): Promise<RetryGooglePushSuccess> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<RetryGooglePushSuccess>(getRetryChecklistGooglePushUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(retryGooglePushRequest)
  }
);}





export const getRetryChecklistGooglePushMutationKey = () => ['retryChecklistGooglePush'] as const;

export const getRetryChecklistGooglePushMutationOptions = <TError = ErrorType<ErrorEnvelope | ErrorMessage | RetryGooglePushFailure>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryChecklistGooglePush>>, TError,RetryChecklistGooglePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryChecklistGooglePush>>, TError,RetryChecklistGooglePushMutationVariables, TContext> => {

const mutationKey = getRetryChecklistGooglePushMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryChecklistGooglePush>>, RetryChecklistGooglePushMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  retryChecklistGooglePush(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryChecklistGooglePushMutationResult = NonNullable<Awaited<ReturnType<typeof retryChecklistGooglePush>>>
    export type RetryChecklistGooglePushMutationBody = BodyType<RetryGooglePushRequest>
    export type RetryChecklistGooglePushMutationError = ErrorType<ErrorEnvelope | ErrorMessage | RetryGooglePushFailure>
    export type RetryChecklistGooglePushMutationVariables = {id: string;data: BodyType<RetryGooglePushRequest>}

    /**
 * @summary Retry a failed Google Calendar push for a scheduled checklist
 */
export const useRetryChecklistGooglePush = <TError = ErrorType<ErrorEnvelope | ErrorMessage | RetryGooglePushFailure>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryChecklistGooglePush>>, TError,RetryChecklistGooglePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryChecklistGooglePush>>,
        TError,
        RetryChecklistGooglePushMutationVariables,
        TContext
      > => {
      return useMutation(getRetryChecklistGooglePushMutationOptions(options));
    }

export const getTriggerBackupCheckUrl = () => {




  return `/api/internal/scheduler/backup-check`
}

/**
 * Machine-to-machine endpoint for an external cron (e.g. a Replit Scheduled Deployment) to ensure the hourly backup check runs even when the autoscale app has no traffic and no instance is alive to tick its internal setInterval. Requires a `Bearer SCHEDULER_TRIGGER_TOKEN` Authorization header; fail-closed (401) when the secret is unset or short. Returns 202 immediately and runs the check in the background.
 * @summary External scheduler trigger for the backup check
 */
export const triggerBackupCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<SchedulerTriggerAccepted> => {

  return customFetch<SchedulerTriggerAccepted>(getTriggerBackupCheckUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTriggerBackupCheckMutationKey = () => ['triggerBackupCheck'] as const;

export const getTriggerBackupCheckMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerBackupCheck>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerBackupCheck>>, TError,void, TContext> => {

const mutationKey = getTriggerBackupCheckMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerBackupCheck>>, void> = () => {


          return  triggerBackupCheck(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerBackupCheckMutationResult = NonNullable<Awaited<ReturnType<typeof triggerBackupCheck>>>

    export type TriggerBackupCheckMutationError = ErrorType<ErrorMessage>


    /**
 * @summary External scheduler trigger for the backup check
 */
export const useTriggerBackupCheck = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerBackupCheck>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerBackupCheck>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTriggerBackupCheckMutationOptions(options));
    }

export const getBulkDeleteTasksUrl = () => {




  return `/api/tasks/bulk-delete`
}

/**
 * Deletes all selected tasks and revokes assignment-created attachment shares in one transaction. If any task is not owned by the caller or any write fails, nothing is deleted.
 * @summary Delete owned tasks atomically
 */
export const bulkDeleteTasks = async (taskBulkDeletionInput: TaskBulkDeletionInput, options?: Parameters<typeof customFetch>[1]): Promise<TaskBulkDeletionResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TaskBulkDeletionResult>(getBulkDeleteTasksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taskBulkDeletionInput)
  }
);}





export const getBulkDeleteTasksMutationKey = () => ['bulkDeleteTasks'] as const;

export const getBulkDeleteTasksMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteTasks>>, TError,BulkDeleteTasksMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteTasks>>, TError,BulkDeleteTasksMutationVariables, TContext> => {

const mutationKey = getBulkDeleteTasksMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteTasks>>, BulkDeleteTasksMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteTasks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteTasksMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteTasks>>>
    export type BulkDeleteTasksMutationBody = BodyType<TaskBulkDeletionInput>
    export type BulkDeleteTasksMutationError = ErrorType<ErrorEnvelope>
    export type BulkDeleteTasksMutationVariables = {data: BodyType<TaskBulkDeletionInput>}

    /**
 * @summary Delete owned tasks atomically
 */
export const useBulkDeleteTasks = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteTasks>>, TError,BulkDeleteTasksMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteTasks>>,
        TError,
        BulkDeleteTasksMutationVariables,
        TContext
      > => {
      return useMutation(getBulkDeleteTasksMutationOptions(options));
    }

export const getCreateTaskUrl = () => {




  return `/api/tasks`
}

/**
 * Creates a new task for the authenticated user. Accepts an optional Idempotency-Key header; a duplicate request carrying the same key within 60 seconds returns the original 201 response without inserting a second row — safe to retry on flaky connections or proxy retries. For recurring tasks the response shape differs (see CreateRecurringTasksResponse).
 * @summary Create a task
 */
export const createTask = async (createTaskRequest: CreateTaskRequest, options?: Parameters<typeof customFetch>[1]): Promise<CreateTaskResponse | CreateRecurringTasksResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CreateTaskResponse | CreateRecurringTasksResponse>(getCreateTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTaskRequest)
  }
);}





export const getCreateTaskMutationKey = () => ['createTask'] as const;

export const getCreateTaskMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,CreateTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,CreateTaskMutationVariables, TContext> => {

const mutationKey = getCreateTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, CreateTaskMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = BodyType<CreateTaskRequest>
    export type CreateTaskMutationError = ErrorType<ErrorMessage>
    export type CreateTaskMutationVariables = {data: BodyType<CreateTaskRequest>}

    /**
 * @summary Create a task
 */
export const useCreateTask = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,CreateTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        CreateTaskMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options));
    }

export const getListInternalCalendarsUrl = () => {




  return `/api/calendar/internal-calendars`
}

/**
 * Returns the authenticated user's GoalVia-owned calendars in display order.
 * @summary List internal calendars
 */
export const listInternalCalendars = async ( options?: Parameters<typeof customFetch>[1]): Promise<InternalCalendar[]> => {

  return customFetch<InternalCalendar[]>(getListInternalCalendarsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInternalCalendarsQueryKey = () => {
    return [
    `/api/calendar/internal-calendars`
    ] as const;
    }


export const getListInternalCalendarsQueryOptions = <TData = Awaited<ReturnType<typeof listInternalCalendars>>, TError = ErrorType<ErrorMessage | ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInternalCalendars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInternalCalendarsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInternalCalendars>>> = ({ signal }) => listInternalCalendars({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInternalCalendars>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInternalCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof listInternalCalendars>>>
export type ListInternalCalendarsQueryError = ErrorType<ErrorMessage | ErrorEnvelope>


/**
 * @summary List internal calendars
 */

export function useListInternalCalendars<TData = Awaited<ReturnType<typeof listInternalCalendars>>, TError = ErrorType<ErrorMessage | ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInternalCalendars>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInternalCalendarsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateInternalCalendarUrl = () => {




  return `/api/calendar/internal-calendars`
}

/**
 * Creates a GoalVia-owned calendar for the authenticated user.
 * @summary Create an internal calendar
 */
export const createInternalCalendar = async (internalCalendarInput: InternalCalendarInput, options?: Parameters<typeof customFetch>[1]): Promise<InternalCalendar> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<InternalCalendar>(getCreateInternalCalendarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(internalCalendarInput)
  }
);}





export const getCreateInternalCalendarMutationKey = () => ['createInternalCalendar'] as const;

export const getCreateInternalCalendarMutationOptions = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInternalCalendar>>, TError,CreateInternalCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInternalCalendar>>, TError,CreateInternalCalendarMutationVariables, TContext> => {

const mutationKey = getCreateInternalCalendarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInternalCalendar>>, CreateInternalCalendarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createInternalCalendar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInternalCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof createInternalCalendar>>>
    export type CreateInternalCalendarMutationBody = BodyType<InternalCalendarInput>
    export type CreateInternalCalendarMutationError = ErrorType<ErrorEnvelope | ErrorMessage>
    export type CreateInternalCalendarMutationVariables = {data: BodyType<InternalCalendarInput>}

    /**
 * @summary Create an internal calendar
 */
export const useCreateInternalCalendar = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInternalCalendar>>, TError,CreateInternalCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInternalCalendar>>,
        TError,
        CreateInternalCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInternalCalendarMutationOptions(options));
    }

export const getUpdateInternalCalendarUrl = (id: string,) => {




  return `/api/calendar/internal-calendars/${id}`
}

/**
 * Updates one or more editable fields on an authenticated user's internal calendar.
 * @summary Update an internal calendar
 */
export const updateInternalCalendar = async (id: string,
    internalCalendarUpdate: InternalCalendarUpdate, options?: Parameters<typeof customFetch>[1]): Promise<InternalCalendar> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<InternalCalendar>(getUpdateInternalCalendarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(internalCalendarUpdate)
  }
);}





export const getUpdateInternalCalendarMutationKey = () => ['updateInternalCalendar'] as const;

export const getUpdateInternalCalendarMutationOptions = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalCalendar>>, TError,UpdateInternalCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInternalCalendar>>, TError,UpdateInternalCalendarMutationVariables, TContext> => {

const mutationKey = getUpdateInternalCalendarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInternalCalendar>>, UpdateInternalCalendarMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateInternalCalendar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInternalCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof updateInternalCalendar>>>
    export type UpdateInternalCalendarMutationBody = BodyType<InternalCalendarUpdate>
    export type UpdateInternalCalendarMutationError = ErrorType<ErrorEnvelope | ErrorMessage>
    export type UpdateInternalCalendarMutationVariables = {id: string;data: BodyType<InternalCalendarUpdate>}

    /**
 * @summary Update an internal calendar
 */
export const useUpdateInternalCalendar = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalCalendar>>, TError,UpdateInternalCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInternalCalendar>>,
        TError,
        UpdateInternalCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateInternalCalendarMutationOptions(options));
    }

export const getDeleteInternalCalendarUrl = (id: string,) => {




  return `/api/calendar/internal-calendars/${id}`
}

/**
 * Deletes an authenticated user's non-default internal calendar.
 * @summary Delete an internal calendar
 */
export const deleteInternalCalendar = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteInternalCalendarUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInternalCalendarMutationKey = () => ['deleteInternalCalendar'] as const;

export const getDeleteInternalCalendarMutationOptions = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInternalCalendar>>, TError,DeleteInternalCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInternalCalendar>>, TError,DeleteInternalCalendarMutationVariables, TContext> => {

const mutationKey = getDeleteInternalCalendarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInternalCalendar>>, DeleteInternalCalendarMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteInternalCalendar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInternalCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInternalCalendar>>>

    export type DeleteInternalCalendarMutationError = ErrorType<ErrorEnvelope | ErrorMessage>
    export type DeleteInternalCalendarMutationVariables = {id: string}

    /**
 * @summary Delete an internal calendar
 */
export const useDeleteInternalCalendar = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInternalCalendar>>, TError,DeleteInternalCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInternalCalendar>>,
        TError,
        DeleteInternalCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteInternalCalendarMutationOptions(options));
    }

export const getCloneCalendarEventUrl = (id: string,) => {




  return `/api/calendar/${id}/clone`
}

/**
 * Copies safe event content into an owned internal calendar or a writable connected provider calendar. Provider IDs, recurrence, checklist, goal, task, habit, completion, and source identity are never copied.
 * @summary Clone a single calendar event
 */
export const cloneCalendarEvent = async (id: string,
    calendarEventCloneInput: CalendarEventCloneInput, options?: Parameters<typeof customFetch>[1]): Promise<ClonedCalendarEvent> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ClonedCalendarEvent>(getCloneCalendarEventUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(calendarEventCloneInput)
  }
);}





export const getCloneCalendarEventMutationKey = () => ['cloneCalendarEvent'] as const;

export const getCloneCalendarEventMutationOptions = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneCalendarEvent>>, TError,CloneCalendarEventMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneCalendarEvent>>, TError,CloneCalendarEventMutationVariables, TContext> => {

const mutationKey = getCloneCalendarEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneCalendarEvent>>, CloneCalendarEventMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  cloneCalendarEvent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof cloneCalendarEvent>>>
    export type CloneCalendarEventMutationBody = BodyType<CalendarEventCloneInput>
    export type CloneCalendarEventMutationError = ErrorType<ErrorEnvelope | ErrorMessage>
    export type CloneCalendarEventMutationVariables = {id: string;data: BodyType<CalendarEventCloneInput>}

    /**
 * @summary Clone a single calendar event
 */
export const useCloneCalendarEvent = <TError = ErrorType<ErrorEnvelope | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneCalendarEvent>>, TError,CloneCalendarEventMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cloneCalendarEvent>>,
        TError,
        CloneCalendarEventMutationVariables,
        TContext
      > => {
      return useMutation(getCloneCalendarEventMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListVisionBoardsUrl = () => {




  return `/api/vision-boards`
}

/**
 * Returns the authenticated user's vision boards ordered by sortOrder then createdAt
 * @summary List vision boards
 */
export const listVisionBoards = async ( options?: Parameters<typeof customFetch>[1]): Promise<VisionBoard[]> => {

  return customFetch<VisionBoard[]>(getListVisionBoardsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVisionBoardsQueryKey = () => {
    return [
    `/api/vision-boards`
    ] as const;
    }


export const getListVisionBoardsQueryOptions = <TData = Awaited<ReturnType<typeof listVisionBoards>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVisionBoards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVisionBoardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVisionBoards>>> = ({ signal }) => listVisionBoards({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVisionBoards>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVisionBoardsQueryResult = NonNullable<Awaited<ReturnType<typeof listVisionBoards>>>
export type ListVisionBoardsQueryError = ErrorType<unknown>


/**
 * @summary List vision boards
 */

export function useListVisionBoards<TData = Awaited<ReturnType<typeof listVisionBoards>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVisionBoards>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVisionBoardsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateVisionBoardUrl = () => {




  return `/api/vision-boards`
}

/**
 * Creates a vision board with a name, display mode, slide interval, and up to 10 images
 * @summary Create a vision board
 */
export const createVisionBoard = async (visionBoardInput: VisionBoardInput, options?: Parameters<typeof customFetch>[1]): Promise<VisionBoard> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VisionBoard>(getCreateVisionBoardUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(visionBoardInput)
  }
);}





export const getCreateVisionBoardMutationKey = () => ['createVisionBoard'] as const;

export const getCreateVisionBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVisionBoard>>, TError,CreateVisionBoardMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVisionBoard>>, TError,CreateVisionBoardMutationVariables, TContext> => {

const mutationKey = getCreateVisionBoardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVisionBoard>>, CreateVisionBoardMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createVisionBoard(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVisionBoardMutationResult = NonNullable<Awaited<ReturnType<typeof createVisionBoard>>>
    export type CreateVisionBoardMutationBody = BodyType<VisionBoardInput>
    export type CreateVisionBoardMutationError = ErrorType<void>
    export type CreateVisionBoardMutationVariables = {data: BodyType<VisionBoardInput>}

    /**
 * @summary Create a vision board
 */
export const useCreateVisionBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVisionBoard>>, TError,CreateVisionBoardMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVisionBoard>>,
        TError,
        CreateVisionBoardMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVisionBoardMutationOptions(options));
    }

export const getUpdateVisionBoardUrl = (id: string,) => {




  return `/api/vision-boards/${id}`
}

/**
 * Updates any subset of name, displayMode, slideIntervalSeconds, and images
 * @summary Update a vision board
 */
export const updateVisionBoard = async (id: string,
    visionBoardInput: VisionBoardInput, options?: Parameters<typeof customFetch>[1]): Promise<VisionBoard> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VisionBoard>(getUpdateVisionBoardUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(visionBoardInput)
  }
);}





export const getUpdateVisionBoardMutationKey = () => ['updateVisionBoard'] as const;

export const getUpdateVisionBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVisionBoard>>, TError,UpdateVisionBoardMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVisionBoard>>, TError,UpdateVisionBoardMutationVariables, TContext> => {

const mutationKey = getUpdateVisionBoardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVisionBoard>>, UpdateVisionBoardMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateVisionBoard(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVisionBoardMutationResult = NonNullable<Awaited<ReturnType<typeof updateVisionBoard>>>
    export type UpdateVisionBoardMutationBody = BodyType<VisionBoardInput>
    export type UpdateVisionBoardMutationError = ErrorType<void>
    export type UpdateVisionBoardMutationVariables = {id: string;data: BodyType<VisionBoardInput>}

    /**
 * @summary Update a vision board
 */
export const useUpdateVisionBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVisionBoard>>, TError,UpdateVisionBoardMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVisionBoard>>,
        TError,
        UpdateVisionBoardMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVisionBoardMutationOptions(options));
    }

export const getDeleteVisionBoardUrl = (id: string,) => {




  return `/api/vision-boards/${id}`
}

/**
 * Deletes the vision board owned by the authenticated user
 * @summary Delete a vision board
 */
export const deleteVisionBoard = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteVisionBoardUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteVisionBoardMutationKey = () => ['deleteVisionBoard'] as const;

export const getDeleteVisionBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisionBoard>>, TError,DeleteVisionBoardMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisionBoard>>, TError,DeleteVisionBoardMutationVariables, TContext> => {

const mutationKey = getDeleteVisionBoardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisionBoard>>, DeleteVisionBoardMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteVisionBoard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisionBoardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisionBoard>>>

    export type DeleteVisionBoardMutationError = ErrorType<void>
    export type DeleteVisionBoardMutationVariables = {id: string}

    /**
 * @summary Delete a vision board
 */
export const useDeleteVisionBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisionBoard>>, TError,DeleteVisionBoardMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisionBoard>>,
        TError,
        DeleteVisionBoardMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteVisionBoardMutationOptions(options));
    }

export const getCreateResourceGrantUrl = () => {




  return `/api/resource-grants`
}

export const createResourceGrant = async (resourceGrantInput: ResourceGrantInput, options?: Parameters<typeof customFetch>[1]): Promise<ResourceGrant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ResourceGrant>(getCreateResourceGrantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resourceGrantInput)
  }
);}





export const getCreateResourceGrantMutationKey = () => ['createResourceGrant'] as const;

export const getCreateResourceGrantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceGrant>>, TError,CreateResourceGrantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceGrant>>, TError,CreateResourceGrantMutationVariables, TContext> => {

const mutationKey = getCreateResourceGrantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceGrant>>, CreateResourceGrantMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResourceGrant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceGrantMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceGrant>>>
    export type CreateResourceGrantMutationBody = BodyType<ResourceGrantInput>
    export type CreateResourceGrantMutationError = ErrorType<void>
    export type CreateResourceGrantMutationVariables = {data: BodyType<ResourceGrantInput>}

    export const useCreateResourceGrant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceGrant>>, TError,CreateResourceGrantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createResourceGrant>>,
        TError,
        CreateResourceGrantMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResourceGrantMutationOptions(options));
    }

export const getListSentResourceGrantsUrl = () => {




  return `/api/resource-grants/sent`
}

export const listSentResourceGrants = async ( options?: Parameters<typeof customFetch>[1]): Promise<ResourceGrantListItem[]> => {

  return customFetch<ResourceGrantListItem[]>(getListSentResourceGrantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSentResourceGrantsQueryKey = () => {
    return [
    `/api/resource-grants/sent`
    ] as const;
    }


export const getListSentResourceGrantsQueryOptions = <TData = Awaited<ReturnType<typeof listSentResourceGrants>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSentResourceGrants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSentResourceGrantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSentResourceGrants>>> = ({ signal }) => listSentResourceGrants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSentResourceGrants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSentResourceGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof listSentResourceGrants>>>
export type ListSentResourceGrantsQueryError = ErrorType<unknown>



export function useListSentResourceGrants<TData = Awaited<ReturnType<typeof listSentResourceGrants>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSentResourceGrants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSentResourceGrantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListReceivedResourceGrantsUrl = () => {




  return `/api/resource-grants/received`
}

export const listReceivedResourceGrants = async ( options?: Parameters<typeof customFetch>[1]): Promise<ResourceGrantListItem[]> => {

  return customFetch<ResourceGrantListItem[]>(getListReceivedResourceGrantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReceivedResourceGrantsQueryKey = () => {
    return [
    `/api/resource-grants/received`
    ] as const;
    }


export const getListReceivedResourceGrantsQueryOptions = <TData = Awaited<ReturnType<typeof listReceivedResourceGrants>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReceivedResourceGrants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReceivedResourceGrantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReceivedResourceGrants>>> = ({ signal }) => listReceivedResourceGrants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReceivedResourceGrants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReceivedResourceGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof listReceivedResourceGrants>>>
export type ListReceivedResourceGrantsQueryError = ErrorType<unknown>



export function useListReceivedResourceGrants<TData = Awaited<ReturnType<typeof listReceivedResourceGrants>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReceivedResourceGrants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReceivedResourceGrantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateResourceGrantUrl = (id: string,) => {




  return `/api/resource-grants/${id}`
}

export const updateResourceGrant = async (id: string,
    resourceGrantUpdate: ResourceGrantUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ResourceGrant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ResourceGrant>(getUpdateResourceGrantUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resourceGrantUpdate)
  }
);}





export const getUpdateResourceGrantMutationKey = () => ['updateResourceGrant'] as const;

export const getUpdateResourceGrantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceGrant>>, TError,UpdateResourceGrantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResourceGrant>>, TError,UpdateResourceGrantMutationVariables, TContext> => {

const mutationKey = getUpdateResourceGrantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResourceGrant>>, UpdateResourceGrantMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateResourceGrant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResourceGrantMutationResult = NonNullable<Awaited<ReturnType<typeof updateResourceGrant>>>
    export type UpdateResourceGrantMutationBody = BodyType<ResourceGrantUpdate>
    export type UpdateResourceGrantMutationError = ErrorType<void>
    export type UpdateResourceGrantMutationVariables = {id: string;data: BodyType<ResourceGrantUpdate>}

    export const useUpdateResourceGrant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceGrant>>, TError,UpdateResourceGrantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateResourceGrant>>,
        TError,
        UpdateResourceGrantMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResourceGrantMutationOptions(options));
    }

export const getRevokeResourceGrantUrl = (id: string,) => {




  return `/api/resource-grants/${id}`
}

export const revokeResourceGrant = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRevokeResourceGrantUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeResourceGrantMutationKey = () => ['revokeResourceGrant'] as const;

export const getRevokeResourceGrantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeResourceGrant>>, TError,RevokeResourceGrantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeResourceGrant>>, TError,RevokeResourceGrantMutationVariables, TContext> => {

const mutationKey = getRevokeResourceGrantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeResourceGrant>>, RevokeResourceGrantMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  revokeResourceGrant(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeResourceGrantMutationResult = NonNullable<Awaited<ReturnType<typeof revokeResourceGrant>>>

    export type RevokeResourceGrantMutationError = ErrorType<void>
    export type RevokeResourceGrantMutationVariables = {id: string}

    export const useRevokeResourceGrant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeResourceGrant>>, TError,RevokeResourceGrantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeResourceGrant>>,
        TError,
        RevokeResourceGrantMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeResourceGrantMutationOptions(options));
    }

export const getGetGrantedResourceUrl = (id: string,) => {




  return `/api/resource-grants/${id}/resource`
}

export const getGrantedResource = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<GrantedResource> => {

  return customFetch<GrantedResource>(getGetGrantedResourceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGrantedResourceQueryKey = (id: string,) => {
    return [
    `/api/resource-grants/${id}/resource`
    ] as const;
    }


export const getGetGrantedResourceQueryOptions = <TData = Awaited<ReturnType<typeof getGrantedResource>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrantedResource>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGrantedResourceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrantedResource>>> = ({ signal }) => getGrantedResource(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGrantedResource>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGrantedResourceQueryResult = NonNullable<Awaited<ReturnType<typeof getGrantedResource>>>
export type GetGrantedResourceQueryError = ErrorType<void>



export function useGetGrantedResource<TData = Awaited<ReturnType<typeof getGrantedResource>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGrantedResource>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGrantedResourceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateGrantedResourceUrl = (id: string,) => {




  return `/api/resource-grants/${id}/resource`
}

export const updateGrantedResource = async (id: string,
    grantedResourceUpdate: GrantedResourceUpdate, options?: Parameters<typeof customFetch>[1]): Promise<GrantedResource> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<GrantedResource>(getUpdateGrantedResourceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantedResourceUpdate)
  }
);}





export const getUpdateGrantedResourceMutationKey = () => ['updateGrantedResource'] as const;

export const getUpdateGrantedResourceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGrantedResource>>, TError,UpdateGrantedResourceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGrantedResource>>, TError,UpdateGrantedResourceMutationVariables, TContext> => {

const mutationKey = getUpdateGrantedResourceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGrantedResource>>, UpdateGrantedResourceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateGrantedResource(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGrantedResourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateGrantedResource>>>
    export type UpdateGrantedResourceMutationBody = BodyType<GrantedResourceUpdate>
    export type UpdateGrantedResourceMutationError = ErrorType<void>
    export type UpdateGrantedResourceMutationVariables = {id: string;data: BodyType<GrantedResourceUpdate>}

    export const useUpdateGrantedResource = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGrantedResource>>, TError,UpdateGrantedResourceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGrantedResource>>,
        TError,
        UpdateGrantedResourceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateGrantedResourceMutationOptions(options));
    }

export const getCreateDeletionRequestUrl = (id: string,) => {




  return `/api/resource-grants/${id}/deletion-requests`
}

export const createDeletionRequest = async (id: string,
    deletionRequestInput: DeletionRequestInput, options?: Parameters<typeof customFetch>[1]): Promise<DeletionRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DeletionRequest>(getCreateDeletionRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deletionRequestInput)
  }
);}





export const getCreateDeletionRequestMutationKey = () => ['createDeletionRequest'] as const;

export const getCreateDeletionRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeletionRequest>>, TError,CreateDeletionRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDeletionRequest>>, TError,CreateDeletionRequestMutationVariables, TContext> => {

const mutationKey = getCreateDeletionRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDeletionRequest>>, CreateDeletionRequestMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createDeletionRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDeletionRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createDeletionRequest>>>
    export type CreateDeletionRequestMutationBody = BodyType<DeletionRequestInput>
    export type CreateDeletionRequestMutationError = ErrorType<void>
    export type CreateDeletionRequestMutationVariables = {id: string;data: BodyType<DeletionRequestInput>}

    export const useCreateDeletionRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeletionRequest>>, TError,CreateDeletionRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDeletionRequest>>,
        TError,
        CreateDeletionRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDeletionRequestMutationOptions(options));
    }

export const getDecideDeletionRequestLegacyUrl = (id: string,
    decision: 'approve' | 'reject',) => {




  return `/api/deletion-requests/${id}/${decision}`
}

export const decideDeletionRequestLegacy = async (id: string,
    decision: 'approve' | 'reject',
    deletionRequestInput: DeletionRequestInput, options?: Parameters<typeof customFetch>[1]): Promise<DeletionRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DeletionRequest>(getDecideDeletionRequestLegacyUrl(id,decision),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deletionRequestInput)
  }
);}





export const getDecideDeletionRequestLegacyMutationKey = () => ['decideDeletionRequestLegacy'] as const;

export const getDecideDeletionRequestLegacyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideDeletionRequestLegacy>>, TError,DecideDeletionRequestLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof decideDeletionRequestLegacy>>, TError,DecideDeletionRequestLegacyMutationVariables, TContext> => {

const mutationKey = getDecideDeletionRequestLegacyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decideDeletionRequestLegacy>>, DecideDeletionRequestLegacyMutationVariables> = (props) => {
          const {id,decision,data} = props ?? {};

          return  decideDeletionRequestLegacy(id,decision,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DecideDeletionRequestLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof decideDeletionRequestLegacy>>>
    export type DecideDeletionRequestLegacyMutationBody = BodyType<DeletionRequestInput>
    export type DecideDeletionRequestLegacyMutationError = ErrorType<void>
    export type DecideDeletionRequestLegacyMutationVariables = {id: string;decision: 'approve' | 'reject';data: BodyType<DeletionRequestInput>}

    export const useDecideDeletionRequestLegacy = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideDeletionRequestLegacy>>, TError,DecideDeletionRequestLegacyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof decideDeletionRequestLegacy>>,
        TError,
        DecideDeletionRequestLegacyMutationVariables,
        TContext
      > => {
      return useMutation(getDecideDeletionRequestLegacyMutationOptions(options));
    }

export const getListDeletionRequestsUrl = () => {




  return `/api/deletion-requests`
}

export const listDeletionRequests = async ( options?: Parameters<typeof customFetch>[1]): Promise<DeletionRequestListItem[]> => {

  return customFetch<DeletionRequestListItem[]>(getListDeletionRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDeletionRequestsQueryKey = () => {
    return [
    `/api/deletion-requests`
    ] as const;
    }


export const getListDeletionRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listDeletionRequests>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeletionRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDeletionRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeletionRequests>>> = ({ signal }) => listDeletionRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDeletionRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDeletionRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listDeletionRequests>>>
export type ListDeletionRequestsQueryError = ErrorType<unknown>



export function useListDeletionRequests<TData = Awaited<ReturnType<typeof listDeletionRequests>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeletionRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDeletionRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDecideDeletionRequestUrl = (id: string,
    decision: 'approve' | 'reject',) => {




  return `/api/deletion-requests/${id}/decision/${decision}`
}

export const decideDeletionRequest = async (id: string,
    decision: 'approve' | 'reject',
    deletionRequestInput: DeletionRequestInput, options?: Parameters<typeof customFetch>[1]): Promise<DeletionRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DeletionRequest>(getDecideDeletionRequestUrl(id,decision),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deletionRequestInput)
  }
);}





export const getDecideDeletionRequestMutationKey = () => ['decideDeletionRequest'] as const;

export const getDecideDeletionRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideDeletionRequest>>, TError,DecideDeletionRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof decideDeletionRequest>>, TError,DecideDeletionRequestMutationVariables, TContext> => {

const mutationKey = getDecideDeletionRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decideDeletionRequest>>, DecideDeletionRequestMutationVariables> = (props) => {
          const {id,decision,data} = props ?? {};

          return  decideDeletionRequest(id,decision,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DecideDeletionRequestMutationResult = NonNullable<Awaited<ReturnType<typeof decideDeletionRequest>>>
    export type DecideDeletionRequestMutationBody = BodyType<DeletionRequestInput>
    export type DecideDeletionRequestMutationError = ErrorType<void>
    export type DecideDeletionRequestMutationVariables = {id: string;decision: 'approve' | 'reject';data: BodyType<DeletionRequestInput>}

    export const useDecideDeletionRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideDeletionRequest>>, TError,DecideDeletionRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof decideDeletionRequest>>,
        TError,
        DecideDeletionRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDecideDeletionRequestMutationOptions(options));
    }

export const getExecuteApprovedDeletionUrl = (id: string,) => {




  return `/api/deletion-requests/${id}/resource`
}

export const executeApprovedDeletion = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getExecuteApprovedDeletionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getExecuteApprovedDeletionMutationKey = () => ['executeApprovedDeletion'] as const;

export const getExecuteApprovedDeletionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeApprovedDeletion>>, TError,ExecuteApprovedDeletionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof executeApprovedDeletion>>, TError,ExecuteApprovedDeletionMutationVariables, TContext> => {

const mutationKey = getExecuteApprovedDeletionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeApprovedDeletion>>, ExecuteApprovedDeletionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  executeApprovedDeletion(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteApprovedDeletionMutationResult = NonNullable<Awaited<ReturnType<typeof executeApprovedDeletion>>>

    export type ExecuteApprovedDeletionMutationError = ErrorType<void>
    export type ExecuteApprovedDeletionMutationVariables = {id: string}

    export const useExecuteApprovedDeletion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeApprovedDeletion>>, TError,ExecuteApprovedDeletionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof executeApprovedDeletion>>,
        TError,
        ExecuteApprovedDeletionMutationVariables,
        TContext
      > => {
      return useMutation(getExecuteApprovedDeletionMutationOptions(options));
    }

export const getGetCurrentPlatformPermissionsUrl = () => {




  return `/api/platform/permissions/me`
}

/**
 * @summary Get current effective platform permissions
 */
export const getCurrentPlatformPermissions = async ( options?: Parameters<typeof customFetch>[1]): Promise<PlatformPermissionsResponse> => {

  return customFetch<PlatformPermissionsResponse>(getGetCurrentPlatformPermissionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentPlatformPermissionsQueryKey = () => {
    return [
    `/api/platform/permissions/me`
    ] as const;
    }


export const getGetCurrentPlatformPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentPlatformPermissions>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatformPermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentPlatformPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentPlatformPermissions>>> = ({ signal }) => getCurrentPlatformPermissions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatformPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentPlatformPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentPlatformPermissions>>>
export type GetCurrentPlatformPermissionsQueryError = ErrorType<ErrorMessage>


/**
 * @summary Get current effective platform permissions
 */

export function useGetCurrentPlatformPermissions<TData = Awaited<ReturnType<typeof getCurrentPlatformPermissions>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentPlatformPermissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentPlatformPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPlatformRolesUrl = () => {




  return `/api/platform/roles`
}

/**
 * @summary List platform roles (owner only)
 */
export const listPlatformRoles = async ( options?: Parameters<typeof customFetch>[1]): Promise<PlatformRole[]> => {

  return customFetch<PlatformRole[]>(getListPlatformRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformRolesQueryKey = () => {
    return [
    `/api/platform/roles`
    ] as const;
    }


export const getListPlatformRolesQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformRoles>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformRoles>>> = ({ signal }) => listPlatformRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlatformRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformRoles>>>
export type ListPlatformRolesQueryError = ErrorType<ErrorMessage>


/**
 * @summary List platform roles (owner only)
 */

export function useListPlatformRoles<TData = Awaited<ReturnType<typeof listPlatformRoles>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformRoles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlatformRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePlatformRoleUrl = () => {




  return `/api/platform/roles`
}

/**
 * @summary Create platform role (owner only)
 */
export const createPlatformRole = async (createPlatformRoleRequest: CreatePlatformRoleRequest, options?: Parameters<typeof customFetch>[1]): Promise<PlatformRole> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<PlatformRole>(getCreatePlatformRoleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPlatformRoleRequest)
  }
);}





export const getCreatePlatformRoleMutationKey = () => ['createPlatformRole'] as const;

export const getCreatePlatformRoleMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatformRole>>, TError,CreatePlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlatformRole>>, TError,CreatePlatformRoleMutationVariables, TContext> => {

const mutationKey = getCreatePlatformRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlatformRole>>, CreatePlatformRoleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPlatformRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlatformRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createPlatformRole>>>
    export type CreatePlatformRoleMutationBody = BodyType<CreatePlatformRoleRequest>
    export type CreatePlatformRoleMutationError = ErrorType<ErrorMessage>
    export type CreatePlatformRoleMutationVariables = {data: BodyType<CreatePlatformRoleRequest>}

    /**
 * @summary Create platform role (owner only)
 */
export const useCreatePlatformRole = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlatformRole>>, TError,CreatePlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlatformRole>>,
        TError,
        CreatePlatformRoleMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePlatformRoleMutationOptions(options));
    }

export const getUpdatePlatformRoleUrl = (id: string,) => {




  return `/api/platform/roles/${id}`
}

/**
 * @summary Update platform role (owner only)
 */
export const updatePlatformRole = async (id: string,
    updatePlatformRoleRequest: UpdatePlatformRoleRequest, options?: Parameters<typeof customFetch>[1]): Promise<PlatformRole> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<PlatformRole>(getUpdatePlatformRoleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePlatformRoleRequest)
  }
);}





export const getUpdatePlatformRoleMutationKey = () => ['updatePlatformRole'] as const;

export const getUpdatePlatformRoleMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformRole>>, TError,UpdatePlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformRole>>, TError,UpdatePlatformRoleMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformRole>>, UpdatePlatformRoleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePlatformRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformRole>>>
    export type UpdatePlatformRoleMutationBody = BodyType<UpdatePlatformRoleRequest>
    export type UpdatePlatformRoleMutationError = ErrorType<ErrorMessage>
    export type UpdatePlatformRoleMutationVariables = {id: string;data: BodyType<UpdatePlatformRoleRequest>}

    /**
 * @summary Update platform role (owner only)
 */
export const useUpdatePlatformRole = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformRole>>, TError,UpdatePlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformRole>>,
        TError,
        UpdatePlatformRoleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformRoleMutationOptions(options));
    }

export const getDeletePlatformRoleUrl = (id: string,) => {




  return `/api/platform/roles/${id}`
}

/**
 * @summary Delete platform role (owner only)
 */
export const deletePlatformRole = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeletePlatformRoleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePlatformRoleMutationKey = () => ['deletePlatformRole'] as const;

export const getDeletePlatformRoleMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformRole>>, TError,DeletePlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlatformRole>>, TError,DeletePlatformRoleMutationVariables, TContext> => {

const mutationKey = getDeletePlatformRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlatformRole>>, DeletePlatformRoleMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePlatformRole(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlatformRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlatformRole>>>

    export type DeletePlatformRoleMutationError = ErrorType<ErrorMessage>
    export type DeletePlatformRoleMutationVariables = {id: string}

    /**
 * @summary Delete platform role (owner only)
 */
export const useDeletePlatformRole = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlatformRole>>, TError,DeletePlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePlatformRole>>,
        TError,
        DeletePlatformRoleMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePlatformRoleMutationOptions(options));
    }

export const getAssignPlatformRoleUrl = (id: string,) => {




  return `/api/platform/roles/${id}/assignments`
}

/**
 * @summary Assign platform role (owner only)
 */
export const assignPlatformRole = async (id: string,
    assignPlatformRoleRequest: AssignPlatformRoleRequest, options?: Parameters<typeof customFetch>[1]): Promise<PlatformRoleAssignment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<PlatformRoleAssignment>(getAssignPlatformRoleUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(assignPlatformRoleRequest)
  }
);}





export const getAssignPlatformRoleMutationKey = () => ['assignPlatformRole'] as const;

export const getAssignPlatformRoleMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignPlatformRole>>, TError,AssignPlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignPlatformRole>>, TError,AssignPlatformRoleMutationVariables, TContext> => {

const mutationKey = getAssignPlatformRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignPlatformRole>>, AssignPlatformRoleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  assignPlatformRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignPlatformRoleMutationResult = NonNullable<Awaited<ReturnType<typeof assignPlatformRole>>>
    export type AssignPlatformRoleMutationBody = BodyType<AssignPlatformRoleRequest>
    export type AssignPlatformRoleMutationError = ErrorType<ErrorMessage>
    export type AssignPlatformRoleMutationVariables = {id: string;data: BodyType<AssignPlatformRoleRequest>}

    /**
 * @summary Assign platform role (owner only)
 */
export const useAssignPlatformRole = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignPlatformRole>>, TError,AssignPlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignPlatformRole>>,
        TError,
        AssignPlatformRoleMutationVariables,
        TContext
      > => {
      return useMutation(getAssignPlatformRoleMutationOptions(options));
    }

export const getListPlatformRoleAssignmentsUrl = () => {




  return `/api/platform/role-assignments`
}

/**
 * @summary List platform role assignments (owner only)
 */
export const listPlatformRoleAssignments = async ( options?: Parameters<typeof customFetch>[1]): Promise<PlatformRoleAssignmentWithLabels[]> => {

  return customFetch<PlatformRoleAssignmentWithLabels[]>(getListPlatformRoleAssignmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformRoleAssignmentsQueryKey = () => {
    return [
    `/api/platform/role-assignments`
    ] as const;
    }


export const getListPlatformRoleAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformRoleAssignments>>, TError = ErrorType<ErrorMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformRoleAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformRoleAssignmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformRoleAssignments>>> = ({ signal }) => listPlatformRoleAssignments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformRoleAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlatformRoleAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformRoleAssignments>>>
export type ListPlatformRoleAssignmentsQueryError = ErrorType<ErrorMessage>


/**
 * @summary List platform role assignments (owner only)
 */

export function useListPlatformRoleAssignments<TData = Awaited<ReturnType<typeof listPlatformRoleAssignments>>, TError = ErrorType<ErrorMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformRoleAssignments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlatformRoleAssignmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUnassignPlatformRoleUrl = (id: string,
    userId: string,) => {




  return `/api/platform/roles/${id}/assignments/${userId}`
}

/**
 * @summary Remove platform role assignment (owner only)
 */
export const unassignPlatformRole = async (id: string,
    userId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getUnassignPlatformRoleUrl(id,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnassignPlatformRoleMutationKey = () => ['unassignPlatformRole'] as const;

export const getUnassignPlatformRoleMutationOptions = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignPlatformRole>>, TError,UnassignPlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignPlatformRole>>, TError,UnassignPlatformRoleMutationVariables, TContext> => {

const mutationKey = getUnassignPlatformRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignPlatformRole>>, UnassignPlatformRoleMutationVariables> = (props) => {
          const {id,userId} = props ?? {};

          return  unassignPlatformRole(id,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignPlatformRoleMutationResult = NonNullable<Awaited<ReturnType<typeof unassignPlatformRole>>>

    export type UnassignPlatformRoleMutationError = ErrorType<ErrorMessage>
    export type UnassignPlatformRoleMutationVariables = {id: string;userId: string}

    /**
 * @summary Remove platform role assignment (owner only)
 */
export const useUnassignPlatformRole = <TError = ErrorType<ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignPlatformRole>>, TError,UnassignPlatformRoleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unassignPlatformRole>>,
        TError,
        UnassignPlatformRoleMutationVariables,
        TContext
      > => {
      return useMutation(getUnassignPlatformRoleMutationOptions(options));
    }

export const getAnalyzeScorecardPerformanceUrl = () => {




  return `/api/scorecard/analyze`
}

/**
 * Aggregates the authenticated user's goals, habits, tasks, trackers, health, and calendar data for the requested period and produces an AI-generated scorecard with scores (1-10 per category), a composite score, strengths, improvement areas, a coach message, and priority actions.
 * @summary Generate an AI-powered performance scorecard
 */
export const analyzeScorecardPerformance = async (scorecardAnalyzeRequest: ScorecardAnalyzeRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScorecardAnalyzeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ScorecardAnalyzeResponse>(getAnalyzeScorecardPerformanceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scorecardAnalyzeRequest)
  }
);}





export const getAnalyzeScorecardPerformanceMutationKey = () => ['analyzeScorecardPerformance'] as const;

export const getAnalyzeScorecardPerformanceMutationOptions = <TError = ErrorType<ScorecardErrorResponse | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeScorecardPerformance>>, TError,AnalyzeScorecardPerformanceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeScorecardPerformance>>, TError,AnalyzeScorecardPerformanceMutationVariables, TContext> => {

const mutationKey = getAnalyzeScorecardPerformanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeScorecardPerformance>>, AnalyzeScorecardPerformanceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  analyzeScorecardPerformance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeScorecardPerformanceMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeScorecardPerformance>>>
    export type AnalyzeScorecardPerformanceMutationBody = BodyType<ScorecardAnalyzeRequest>
    export type AnalyzeScorecardPerformanceMutationError = ErrorType<ScorecardErrorResponse | ErrorMessage>
    export type AnalyzeScorecardPerformanceMutationVariables = {data: BodyType<ScorecardAnalyzeRequest>}

    /**
 * @summary Generate an AI-powered performance scorecard
 */
export const useAnalyzeScorecardPerformance = <TError = ErrorType<ScorecardErrorResponse | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeScorecardPerformance>>, TError,AnalyzeScorecardPerformanceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeScorecardPerformance>>,
        TError,
        AnalyzeScorecardPerformanceMutationVariables,
        TContext
      > => {
      return useMutation(getAnalyzeScorecardPerformanceMutationOptions(options));
    }

export const getScorecardChatUrl = () => {




  return `/api/scorecard/chat`
}

/**
 * Sends a user message to the AI performance coach, optionally including the current scorecard context and prior conversation history so the coach can reference specific scores and metrics in its reply.
 * @summary Chat with the AI performance coach
 */
export const scorecardChat = async (scorecardChatRequest: ScorecardChatRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScorecardChatResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ScorecardChatResponse>(getScorecardChatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scorecardChatRequest)
  }
);}





export const getScorecardChatMutationKey = () => ['scorecardChat'] as const;

export const getScorecardChatMutationOptions = <TError = ErrorType<ScorecardErrorResponse | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scorecardChat>>, TError,ScorecardChatMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scorecardChat>>, TError,ScorecardChatMutationVariables, TContext> => {

const mutationKey = getScorecardChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scorecardChat>>, ScorecardChatMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  scorecardChat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScorecardChatMutationResult = NonNullable<Awaited<ReturnType<typeof scorecardChat>>>
    export type ScorecardChatMutationBody = BodyType<ScorecardChatRequest>
    export type ScorecardChatMutationError = ErrorType<ScorecardErrorResponse | ErrorMessage>
    export type ScorecardChatMutationVariables = {data: BodyType<ScorecardChatRequest>}

    /**
 * @summary Chat with the AI performance coach
 */
export const useScorecardChat = <TError = ErrorType<ScorecardErrorResponse | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scorecardChat>>, TError,ScorecardChatMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof scorecardChat>>,
        TError,
        ScorecardChatMutationVariables,
        TContext
      > => {
      return useMutation(getScorecardChatMutationOptions(options));
    }

export const getGetScorecardTrendUrl = () => {




  return `/api/scorecard/trend`
}

/**
 * Returns an array of time-bucketed scorecard snapshots (one per period bucket) computed from rule-based scoring without AI. Useful for rendering trend charts. Max window counts: daily=30, weekly=4, monthly=3, quarterly=4, yearly=3.
 * @summary Compute rule-based scorecard trend over time buckets
 */
export const getScorecardTrend = async (scorecardTrendRequest: ScorecardTrendRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScorecardTrendPoint[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ScorecardTrendPoint[]>(getGetScorecardTrendUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scorecardTrendRequest)
  }
);}





export const getGetScorecardTrendMutationKey = () => ['getScorecardTrend'] as const;

export const getGetScorecardTrendMutationOptions = <TError = ErrorType<ScorecardErrorResponse | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScorecardTrend>>, TError,GetScorecardTrendMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getScorecardTrend>>, TError,GetScorecardTrendMutationVariables, TContext> => {

const mutationKey = getGetScorecardTrendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getScorecardTrend>>, GetScorecardTrendMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getScorecardTrend(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetScorecardTrendMutationResult = NonNullable<Awaited<ReturnType<typeof getScorecardTrend>>>
    export type GetScorecardTrendMutationBody = BodyType<ScorecardTrendRequest>
    export type GetScorecardTrendMutationError = ErrorType<ScorecardErrorResponse | ErrorMessage>
    export type GetScorecardTrendMutationVariables = {data: BodyType<ScorecardTrendRequest>}

    /**
 * @summary Compute rule-based scorecard trend over time buckets
 */
export const useGetScorecardTrend = <TError = ErrorType<ScorecardErrorResponse | ErrorMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScorecardTrend>>, TError,GetScorecardTrendMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof getScorecardTrend>>,
        TError,
        GetScorecardTrendMutationVariables,
        TContext
      > => {
      return useMutation(getGetScorecardTrendMutationOptions(options));
    }

export const getGetRelationshipSpendingBudgetUrl = (personUserId: string,) => {




  return `/api/spending/budgets/${personUserId}`
}

/**
 * @summary Get the daily spending budget for an assistant or family relationship
 */
export const getRelationshipSpendingBudget = async (personUserId: string, options?: Parameters<typeof customFetch>[1]): Promise<RelationshipSpendingBudget> => {

  return customFetch<RelationshipSpendingBudget>(getGetRelationshipSpendingBudgetUrl(personUserId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRelationshipSpendingBudgetQueryKey = (personUserId: string,) => {
    return [
    `/api/spending/budgets/${personUserId}`
    ] as const;
    }


export const getGetRelationshipSpendingBudgetQueryOptions = <TData = Awaited<ReturnType<typeof getRelationshipSpendingBudget>>, TError = ErrorType<void>>(personUserId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRelationshipSpendingBudget>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRelationshipSpendingBudgetQueryKey(personUserId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRelationshipSpendingBudget>>> = ({ signal }) => getRelationshipSpendingBudget(personUserId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: personUserId !== null && personUserId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRelationshipSpendingBudget>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRelationshipSpendingBudgetQueryResult = NonNullable<Awaited<ReturnType<typeof getRelationshipSpendingBudget>>>
export type GetRelationshipSpendingBudgetQueryError = ErrorType<void>


/**
 * @summary Get the daily spending budget for an assistant or family relationship
 */

export function useGetRelationshipSpendingBudget<TData = Awaited<ReturnType<typeof getRelationshipSpendingBudget>>, TError = ErrorType<void>>(
 personUserId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRelationshipSpendingBudget>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRelationshipSpendingBudgetQueryOptions(personUserId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateRelationshipSpendingBudgetUrl = (personUserId: string,) => {




  return `/api/spending/budgets/${personUserId}`
}

/**
 * @summary Set the daily spending budget for an assistant or family relationship
 */
export const updateRelationshipSpendingBudget = async (personUserId: string,
    relationshipSpendingBudgetUpdate: RelationshipSpendingBudgetUpdate, options?: Parameters<typeof customFetch>[1]): Promise<RelationshipSpendingBudget> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<RelationshipSpendingBudget>(getUpdateRelationshipSpendingBudgetUrl(personUserId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(relationshipSpendingBudgetUpdate)
  }
);}





export const getUpdateRelationshipSpendingBudgetMutationKey = () => ['updateRelationshipSpendingBudget'] as const;

export const getUpdateRelationshipSpendingBudgetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRelationshipSpendingBudget>>, TError,UpdateRelationshipSpendingBudgetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRelationshipSpendingBudget>>, TError,UpdateRelationshipSpendingBudgetMutationVariables, TContext> => {

const mutationKey = getUpdateRelationshipSpendingBudgetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRelationshipSpendingBudget>>, UpdateRelationshipSpendingBudgetMutationVariables> = (props) => {
          const {personUserId,data} = props ?? {};

          return  updateRelationshipSpendingBudget(personUserId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRelationshipSpendingBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof updateRelationshipSpendingBudget>>>
    export type UpdateRelationshipSpendingBudgetMutationBody = BodyType<RelationshipSpendingBudgetUpdate>
    export type UpdateRelationshipSpendingBudgetMutationError = ErrorType<void>
    export type UpdateRelationshipSpendingBudgetMutationVariables = {personUserId: string;data: BodyType<RelationshipSpendingBudgetUpdate>}

    /**
 * @summary Set the daily spending budget for an assistant or family relationship
 */
export const useUpdateRelationshipSpendingBudget = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRelationshipSpendingBudget>>, TError,UpdateRelationshipSpendingBudgetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRelationshipSpendingBudget>>,
        TError,
        UpdateRelationshipSpendingBudgetMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRelationshipSpendingBudgetMutationOptions(options));
    }

export const getApproveRelationshipSpendingUrl = (approvalId: string,) => {




  return `/api/spending/approvals/${approvalId}/approve`
}

/**
 * @summary Approve additional spending for an assistant or family relationship
 */
export const approveRelationshipSpending = async (approvalId: string,
    relationshipSpendingApprovalUpdate?: RelationshipSpendingApprovalUpdate, options?: Parameters<typeof customFetch>[1]): Promise<RelationshipSpendingApproval> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<RelationshipSpendingApproval>(getApproveRelationshipSpendingUrl(approvalId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(relationshipSpendingApprovalUpdate)
  }
);}





export const getApproveRelationshipSpendingMutationKey = () => ['approveRelationshipSpending'] as const;

export const getApproveRelationshipSpendingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRelationshipSpending>>, TError,ApproveRelationshipSpendingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveRelationshipSpending>>, TError,ApproveRelationshipSpendingMutationVariables, TContext> => {

const mutationKey = getApproveRelationshipSpendingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveRelationshipSpending>>, ApproveRelationshipSpendingMutationVariables> = (props) => {
          const {approvalId,data} = props ?? {};

          return  approveRelationshipSpending(approvalId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveRelationshipSpendingMutationResult = NonNullable<Awaited<ReturnType<typeof approveRelationshipSpending>>>
    export type ApproveRelationshipSpendingMutationBody = BodyType<RelationshipSpendingApprovalUpdate> | undefined
    export type ApproveRelationshipSpendingMutationError = ErrorType<void>
    export type ApproveRelationshipSpendingMutationVariables = {approvalId: string;data?: BodyType<RelationshipSpendingApprovalUpdate>}

    /**
 * @summary Approve additional spending for an assistant or family relationship
 */
export const useApproveRelationshipSpending = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveRelationshipSpending>>, TError,ApproveRelationshipSpendingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveRelationshipSpending>>,
        TError,
        ApproveRelationshipSpendingMutationVariables,
        TContext
      > => {
      return useMutation(getApproveRelationshipSpendingMutationOptions(options));
    }

export const getDenyRelationshipSpendingUrl = (approvalId: string,) => {




  return `/api/spending/approvals/${approvalId}/deny`
}

/**
 * @summary Deny additional spending for an assistant or family relationship
 */
export const denyRelationshipSpending = async (approvalId: string, options?: Parameters<typeof customFetch>[1]): Promise<RelationshipSpendingApproval> => {

  return customFetch<RelationshipSpendingApproval>(getDenyRelationshipSpendingUrl(approvalId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDenyRelationshipSpendingMutationKey = () => ['denyRelationshipSpending'] as const;

export const getDenyRelationshipSpendingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyRelationshipSpending>>, TError,DenyRelationshipSpendingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof denyRelationshipSpending>>, TError,DenyRelationshipSpendingMutationVariables, TContext> => {

const mutationKey = getDenyRelationshipSpendingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyRelationshipSpending>>, DenyRelationshipSpendingMutationVariables> = (props) => {
          const {approvalId} = props ?? {};

          return  denyRelationshipSpending(approvalId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyRelationshipSpendingMutationResult = NonNullable<Awaited<ReturnType<typeof denyRelationshipSpending>>>

    export type DenyRelationshipSpendingMutationError = ErrorType<void>
    export type DenyRelationshipSpendingMutationVariables = {approvalId: string}

    /**
 * @summary Deny additional spending for an assistant or family relationship
 */
export const useDenyRelationshipSpending = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyRelationshipSpending>>, TError,DenyRelationshipSpendingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof denyRelationshipSpending>>,
        TError,
        DenyRelationshipSpendingMutationVariables,
        TContext
      > => {
      return useMutation(getDenyRelationshipSpendingMutationOptions(options));
    }

